{
  "recruiting": "Recrutement",
  "courses": "Cours",
  "courses-page": {
    "title": "Cours",
    "create": "Créer un cours",
    "edit": "Modifier le cours",
    "empty": "Aucun cours pour l'instant",
    "fields": {
      "title": "Titre",
      "description": "Description",
      "documents-count": "Documents"
    },
    "headers": {
      "title": "Titre",
      "description": "Description",
      "documents": "Documents",
      "actions": "Actions"
    },
    "dialog": {
      "title-label": "Titre",
      "description-label": "Description",
      "documents-label": "Documents",
      "documents-placeholder": "Sélectionnez des documents de la base de connaissances",
      "save": "Enregistrer",
      "cancel": "Annuler"
    },
    "messages": {
      "created": "Cours créé",
      "updated": "Cours mis à jour",
      "deleted": "Cours supprimé",
      "error": "Une erreur s'est produite"
    },
    "confirm-delete": "Supprimer ce cours ? Cette action est irréversible."
  },
  "ai-study-chat": "Chat d'apprentissage IA",
  "ai-study-chat-page": {
    "title": "Chat d'apprentissage IA",
    "new-conversation": "Nouvelle conversation",
    "empty-sidebar": "Aucune conversation pour l'instant",
    "empty-thread": "Choisissez un cours ou un scénario pour commencer à apprendre",
    "untitled": "Nouveau chat",
    "input-placeholder": "Posez votre question…",
    "send": "Envoyer",
    "typing": "L'assistant est en train d'écrire…",
    "sources": "Sources ({count})",
    "score": "pertinence",
    "retry": "Réessayer",
    "failed": "Échec de l'envoi",
    "sources-label": "Sources",
    "copy": "Copier",
    "copied": "Copié",
    "search-placeholder": "Rechercher des conversations",
    "search-empty": "Aucun résultat",
    "empty": {
      "heading": "Prêt à vous aider à apprendre",
      "subtitle": "Posez n'importe quelle question sur les supports du cours — je trouverai la réponse dans la base de connaissances et vous montrerai les sources."
    },
    "groups": {
      "today": "Aujourd'hui",
      "yesterday": "Hier",
      "earlier": "Plus tôt"
    },
    "composer": {
      "context": "Contexte :",
      "hint": "Les réponses sont générées par l'IA à partir de vos supports · Entrée pour envoyer, Maj+Entrée pour une nouvelle ligne"
    },
    "suggestions-fallback": [
      { "title": "Résumer les supports", "subtitle": "Points clés" },
      { "title": "Créer un plan d'étude", "subtitle": "Par où commencer" },
      { "title": "Tester mes connaissances", "subtitle": "Vérification rapide" },
      { "title": "Expliquer simplement", "subtitle": "Sans jargon" }
    ],
    "suggestions-fallback-debrief": [
      { "title": "Débriefer cette session", "subtitle": "Points essentiels" },
      { "title": "Qu'est-ce que j'ai bien fait ?", "subtitle": "Mes points forts" },
      { "title": "Où ai-je échoué et pourquoi ?", "subtitle": "Points de progression" },
      { "title": "Que dois-je améliorer à la prochaine session ?", "subtitle": "Étapes concrètes" }
    ],
    "suggestions-fallback-progress": [
      { "title": "Comment évoluent mes résultats ?", "subtitle": "Entre les sessions" },
      { "title": "Mes compétences fortes et faibles", "subtitle": "D'après les scores" },
      { "title": "Sur quoi devrais-je me concentrer ?", "subtitle": "Priorité d'entraînement" },
      { "title": "Comparer ma première et ma dernière session", "subtitle": "Ce qui s'est amélioré" }
    ],
    "quota": {
      "remaining": "{count} messages restants",
      "exhausted": "Vous avez épuisé vos messages de chat IA.",
      "unavailable": "Le chat IA n'est pas disponible dans votre abonnement."
    },
    "new-dialog": {
      "title": "Nouvelle conversation",
      "subtitle": "Choisissez la source à partir de laquelle l'IA répondra",
      "search": "Rechercher…",
      "search-empty": "Aucun résultat",
      "source-type": "Source",
      "source-course": "Cours",
      "source-scenario": "Scénario",
      "source-competency": "Compétence",
      "pick-course": "Choisir un cours",
      "pick-scenario": "Choisir un scénario",
      "pick-competency": "Choisir une compétence",
      "pick-target": "Toutes les sessions ou une session spécifique",
      "all-games": "Toutes les sessions — ma progression",
      "all-games-sub": "Tendances de score pour cette compétence",
      "back": "Retour",
      "no-games": "Aucune session terminée",
      "empty-competencies": "Aucune session terminée pour le moment",
      "empty-competencies-hint": "Terminez une session sur un scénario avec compétence — l'analyse IA apparaîtra ici",
      "empty-courses": "Aucun cours disponible pour le moment",
      "empty-scenarios": "Aucun scénario disponible pour le moment",
      "tag-game": "Session",
      "start": "Démarrer",
      "cancel": "Annuler"
    },
    "stage": {
      "searching": "Recherche dans vos documents…",
      "reading": "Lecture des sources…",
      "writing": "Rédaction de la réponse…",
      "writing_sources": "Analyse de {count} passages…",
      "summarizing_short": "Organisation du contexte précédent",
      "searching_short": "Recherche dans vos supports",
      "reading_short": "Lecture des sources",
      "writing_short": "Rédaction de la réponse",
      "writing_sources_short": "Analyse de {count} passages"
    },
    "errors": {
      "send": "Impossible d'envoyer votre message. Veuillez réessayer.",
      "quota": "Quota de messages atteint.",
      "rate_limit": "Trop de requêtes. Veuillez patienter une minute et réessayer.",
      "provider_unsupported": "Le chat de la base de connaissances n'est pas disponible avec le fournisseur d'IA actuel de votre organisation.",
      "generic": "Une erreur s'est produite."
    }
  },
  "base_title": "La Réflexion",
  "base_title_ru": "SkillsTrainer",
  "404_title": "Page introuvable ⚠️",
  "404_description": "Nous ne trouvons pas la page que vous recherchez.",
  "404_home": "Retour à l'accueil",
  "401_title": "Vous n'êtes pas autorisé ! 🔐",
  "401_description": "Vous n'avez pas la permission d'accéder à cette page. Retour à l'accueil !",
  "401_home": "Retour à l'accueil",
  "changes_saved": "Modifications enregistrées",
  "coming_soon": "Bientôt disponible",
  " ": " ",
  "select_date_and_time": "Sélectionnez la date et l'heure",
  "select_date": "Sélectionnez la date",
  "chat": "Chat",
  "menu": "Menu",
  "games": "Sessions",
  "tours": "Visites",
  "library": "Bibliothèque",
  "library-video": "Vidéo",
  "library-scorm": "Cours",
  "library-documents": "Documents",
  "scenarios": "Scénarios",
  "competencies": "Compétences",
  "competencies-list": "Liste",
  "skills": "Compétences",
  "home": "Accueil",
  "home_player": "Participant",
  "player": "Participant",
  "home_expert": "Expert",
  "reports-analytics-tours": "Visites",
  "reports": "Rapports",
  "ranking": "Classement",
  "analytics": "Analytique",
  "support": "Support",
  "users": "Utilisateurs",
  "participants": "Participants",
  "departments": "Départements",
  "positions": "Positions",
  "user-custom-fields": "Champs personnalisés",
  "administration": "Administration",
  "ai-assistants": "Assistants IA",
  "ai-profiles": "Profils IA",
  "ai-connectors": "Connecteurs IA",
  "Audit logs": "Journaux d'audit",
  "organizations": "Organisations",
  "loading": "Chargement...",
  "retry": "Réessayer",
  "previous": "Précédent",
  "next": "Suivant",
  "save": "Enregistrer",
  "copy": "Copier",
  "copy_failed": "Impossible de copier automatiquement. Sélectionnez le texte dans le champ et copiez-le manuellement (Ctrl+C ou ⌘C).",
  "confirm": "Confirmer",
  "suggest": "Proposer",
  "generate": "Générer",
  "cancel": "Annuler",
  "close": "Fermer",
  "search": "Rechercher...",
  "accept": "Accepter",
  "propose": "Proposer",
  "decline": "Décliner",
  "send_request": "Envoyer la demande",
  "assign": "Attribuer",
  "actions": " ",
  "evaluators": {
    "ai": "IA",
    "expert": "Expert",
    "player": "Participant",
    "manager": "Gestionnaire",
    "head": "Responsable"
  },
  "statistics": {
    "date_from": "De",
    "date_to": "À",
    "competence": "Compétence",
    "evaluator": "Évaluateur",
    "last_games_effectiveness": {
      "effectiveness": "Efficacité",
      "title": "Efficacité par Sessions"
    },
    "skill_trend": {
      "average_score": "Score Moyen",
      "game": "Session",
      "score": "Score",
      "title": "Score Moyen par Compétences"
    },
    "player_competence_radar": {
      "title": "Statistiques de Compétence",
      "top": "Top 10",
      "players_in_company": "Participants dans l'entreprise",
      "by_games": "Analyse par sessions",
      "subtitle": "Statistiques Générales pour Vous et Votre Entreprise",
      "filter": "Filtre",
      "you": "Vous",
      "company": "Entreprise",
      "average_score": "score moyen",
      "skills_counted": "{counted} compétences sur {total}"
    }
  },
  "participant": {
    "upcoming_games": "Sessions à venir",
    "for_rank_games": "À évaluer"
  },
  "roles": {
    "player": "Participant",
    "admin": "Super administrateur (système)",
    "scoped_admin": "Administrateur principal",
    "observer": "Observateur",
    "captain": "Capitaine",
    "expert": "Expert",
    "lead_expert": "Expert principal",
    "manager": "Gestionnaire",
    "support": "Support",
    "early_access": "Accès anticipé",
    "head": "Responsable",
    "candidate": "Candidat"
  },
  "user-status": {
    "active": "Actif",
    "inactive": "Inactif",
    "pending": "En attente"
  },
  "pagination": {
    "showing": "Affichage",
    "to": "à",
    "of": "de",
    "entries": "entrées"
  },
  "validator": {
    "required": "Ce champ est obligatoire",
    "library": "La taille du fichier doit être inférieure à 500 Mo",
    "email": "Le champ Email doit être un email valide",
    "password": "Le mot de passe doit contenir au minimum une majuscule, une minuscule, un caractère spécial et un chiffre avec un minimum de 8 caractères",
    "confirm": "La confirmation du mot de passe ne correspond pas",
    "at_least": "Ce champ doit contenir au moins",
    "items": "éléments",
    "number": "Ce champ doit être un entier",
    "is_odd": "Ce champ doit être pair",
    "number_between": "Entrez un nombre entre",
    "number_and": "et",
    "date_range_required": "Plage obligatoire",
    "invalid_date_range": "Plage invalide",
    "invalid_date_format": "Format de date invalide",
    "start_date_after_end_date": "La date de début doit être antérieure à la date de fin",
    "max_180_days": "Maximum 180 jours"
  },
  "user": {
    "menu": {
      "settings": "Paramètres",
      "statistics": "Statistiques",
      "logout": "Se déconnecter"
    }
  },
  "theme": {
    "system": "Système",
    "light": "Clair",
    "dark": "Sombre"
  },
  "error": {
    "default": "Désolé, il y a eu une erreur. Nos spécialistes en sont déjà informés et la corrigeront dès que possible.",
    "unauthorized": "Votre session a expiré.",
    "contact-support": "Désolé, il y a eu une erreur. Veuillez contacter le support technique.",
    "forbidden": "Accès refusé"
  },
  "confirmation": {
    "sure": "Êtes-vous sûr de vouloir supprimer l'entrée ?",
    "sure_return_to_time_scheduling": "Êtes-vous sûr de vouloir renvoyer la session à l'étape de coordination de l'heure de début ?",
    "sure_mark_failed": "Marquer la partie comme échouée et supprimer définitivement toutes les évaluations et les protocoles des participants ?",
    "success": "Succès !",
    "deleted": "Supprimé",
    "failed_marked": "Partie marquée comme échouée",
    "cancel": "Annulé",
    "yes": "Oui",
    "no": "Non"
  },
  "dashboards": {
    "player": {
      "summary": {
        "welcome": "Bon retour",
        "progress": "Votre progression globale",
        "stats": {
          "minutes": "Minutes en session",
          "effectiveness": "Efficacité",
          "completed_games_count": "Sessions réussies",
          "total_games_count": "Total des sessions"
        }
      },
      "cards": {
        "players_rating": {
          "title": "Classement de l'entreprise",
          "player": "Participant",
          "effectiveness": "Efficacité"
        }
      }
    },
    "head": {
      "my_stats": "Mes statistiques",
      "subordinates": "Mes subordonnes",
      "subordinate_stats": "Statistiques du subordonne",
      "select_subordinate": "Selectionnez un subordonne pour voir ses statistiques",
      "no_subordinates": "Aucun subordonne attribue"
    }
  },
  "chat-page": {
    "last_game": "Dernière session",
    "chats": "Discussions",
    "no-chats": "Aucune discussion trouvée",
    "contacts": "Contacts",
    "choose": "Choisir un contact",
    "send": "Envoyer",
    "type": "Tapez votre message...",
    "no-contacts": "Aucun contact trouvé",
    "search": "Rechercher...",
    "start_conversation": "Commencer la conversation",
    "start_connecting": " Commencez à vous connecter avec les gens en sélectionnant un contact à gauche"
  },
  "scenarios-page": {
    "title": "Titre",
    "export-docx": "Export .docx",
    "copy_title": "Copier le scénario",
    "generate_ai_title": "Générer un scénario IA",
    "organization": "Entreprise",
    "competence": "Compétence",
    "actions": " ",
    "add": "Ajouter un scénario",
    "ai-generate": "Génération IA",
    "copy": "Copier le scénario",
    "add_popup": "Ajouter un scénario",
    "delete": "Supprimer le scénario",
    "edit": "Modifier le scénario",
    "edit_popup": "Modifier le scénario",
    "industries": [
      "FMCG/Commerce de détail",
      "Pharmaceutique",
      "Banques et Fintech",
      "Hôtels et Tourisme",
      "Entreprises IT/SaaS",
      "Restauration/HoReCa",
      "E-commerce/Places de marché",
      "Fabrication/Industrie 4.0",
      "Logistique et T&L",
      "Télécommunications",
      "Éducation/EdTech",
      "Industrie chimique",
      "Logiciel de gestion de la chaîne d'approvisionnement",
      "Secteur public/Organisations à but non lucratif"
    ],
    "case_types": [
      "Leadership et People-Management",
      "Recrutement et évaluation du personnel",
      "Ventes et service client",
      "Négociations et influence",
      "Gestion des conflits",
      "Stratégie et exécution"
    ],
    "cases": [
      [
        "Définition d'objectifs SMART/OKR",
        "Donner un feedback de développement (SBI/COIN)",
        "Délégation",
        "Coaching GROW",
        "Évaluation de performance",
        "Mentorat"
      ],
      [
        "Entretien basé sur les compétences (CBI)",
        "Évaluation/Centre d'évaluation",
        "Session d'intégration"
      ],
      [
        "Vente classique de produit/service",
        "Traitement des objections",
        "Vente incitative/croisée",
        "Traitement des plaintes",
        "Vente multi-canal"
      ],
      [
        "Négociations internes sur le budget/ressources",
        "Contrat client/fournisseur",
        "Négociations de crise"
      ],
      [
        "Conflit interpersonnel en équipe",
        "Manager-subordonné",
        "Conflit de valeurs/éthique"
      ],
      [
        "Priorisation du portefeuille de projets",
        "Gestion du changement",
        "Analyse des risques"
      ]
    ],
    "formats": [
      "1-1",
      "Groupes"
    ],
    "labels": {
      "industry": "Industrie",
      "case_type": "Type de cas",
      "case": "Cas",
      "format": "Format",
      "duration": "Durée (minutes)",
      "game_vs_ai": "Session contre IA",
      "level": "Niveau",
      "competence": "Compétence",
      "description": "Description du scénario",
      "description_hint": "Décrivez éventuellement le scénario que vous souhaitez générer (max 4000 caractères)"
    },
    "generating_in_progress": "Génération du scénario en cours, veuillez patienter..."
  },
  "analytics-page": {
    "tours-page": {
      "tour": "Visite",
      "full_name": "Participant",
      "games_count": "Sessions",
      "team": "Équipe",
      "export": "Exporter",
      "effectiveness": "Efficacité"
    }
  },
  "report-filters": {
    "department": "Département",
    "position": "Poste",
    "employee": "Employé",
    "scenario": "Scénario",
    "competence": "Compétence",
    "period": "Période",
    "reset": "Réinitialiser",
    "only-period-competence": "Seuls la période et la compétence sont pris en compte"
  },
  "competencies-page": {
    "title": "Titre",
    "export-docx": "Export .docx",
    "skills": "Compétences",
    "text": "Texte",
    "display_order": "Tri",
    "ai-assistant": "Assistant IA",
    "language": "Langue",
    "department": "Département",
    "actions": " ",
    "add": "Ajouter une compétence",
    "add_popup": "Ajouter une compétence",
    "delete": "Supprimer la compétence",
    "edit": "Modifier la compétence",
    "edit_popup": "Modifier la compétence"
  },
  "faq-page": {
    "title": "Questions",
    "question": "Question",
    "text": "Réponse",
    "is_shared": "Disponible pour toutes les entreprises",
    "actions": " ",
    "visibility": "Visibilité",
    "visible_to_all": "Visible pour tous les utilisateurs",
    "visible_to_managers": "Visible uniquement pour les managers",
    "add": "Ajouter une question",
    "add_popup": "Ajouter une question",
    "delete": "Supprimer la question",
    "edit": "Modifier la question",
    "edit_popup": "Modifier la question"
  },
  "ai-connectors-page": {
    "title": "Connecteurs IA",
    "is_shared": "Disponible pour toutes les organisations",
    "actions": " ",
    "add": "Ajouter un connecteur",
    "add_popup": "Ajouter un connecteur",
    "delete": "Supprimer le connecteur",
    "edit": "Modifier le connecteur",
    "edit_popup": "Modifier le connecteur",
    "label": "Libellé",
    "provider": "Fournisseur",
    "service": "Service",
    "organization": "Organisation",
    "status": "Statut",
    "region": "Région",
    "endpoint": "Point de terminaison",
    "secret": "Mot de passe/Clé",
    "maxConcurrency": "Simultanéité maximale",
    "timeoutSec": "Délai d'expiration",
    "sortOrder": "Ordre de tri",
    "config": "Configuration",
    "modelPrimary": "Modèle primary",
    "modelLight": "Modèle light",
    "modelLightHint": "Vide : les appels light utilisent le modèle primary",
    "folderId": "ID de folder",
    "models": "Modèles",
    "is_default": "Default",
    "notes": "Notes"
  },
  "skills-page": {
    "title": "Titre",
    "display_order": "Tri",
    "competence": "Compétence",
    "text": "Indicateurs",
    "actions": " ",
    "add": "Ajouter une compétence",
    "add_popup": "Ajouter une compétence",
    "delete": "Supprimer la compétence",
    "edit": "Modifier la compétence",
    "edit_popup": "Modifier la compétence"
  },
  "departments-page": {
    "title": "Titre",
    "actions": " ",
    "add": "Ajouter un département",
    "add_popup": "Ajouter un département",
    "delete": "Supprimer le département",
    "edit": "Modifier le département",
    "edit_popup": "Modifier le département"
  },
  "tours-page": {
    "title": "Titre",
    "actions": " ",
    "add": "Ajouter une visite",
    "add_popup": "Ajouter une visite",
    "delete": "Supprimer la visite",
    "edit": "Modifier la visite",
    "edit_popup": "Modifier la visite"
  },
  "library-page": {
    "title": "Titre",
    "text": "Description",
    "video": "Vidéo",
    "courses": "Cours",
    "video_link_copy": "Copier le lien",
    "video_in_process": "Vidéo en cours de traitement...",
    "is_public": "Est public",
    "actions": " ",
    "add": "Ajouter une vidéo",
    "add_popup": "Ajouter une vidéo",
    "delete": "Supprimer la vidéo",
    "edit": "Modifier la vidéo",
    "edit_popup": "Modifier la vidéo"
  },
  "library-documents-page": {
    "title": "Titre",
    "actions": " ",
    "add": "Ajouter un document",
    "add_popup": "Ajouter un document",
    "delete": "Supprimer le document",
    "edit": "Modifier le document",
    "edit_popup": "Modifier le document",
    "file": "Fichier"
  },
  "scorm-page": {
    "title": "Titre",
    "actions": " ",
    "add": "Ajouter un cours",
    "loading": "Cours en cours de chargement...",
    "add_popup": "Ajouter un cours",
    "delete": "Supprimer le cours",
    "edit": "Modifier le cours",
    "edit_popup": "Modifier le cours",
    "zip_file": "Fichier ZIP"
  },
  "ai-assistants-page": {
    "external_id": "ID",
    "actions": " ",
    "add": "Ajouter un assistant IA",
    "add_popup": "Ajouter un assistant IA",
    "delete": "Supprimer l'assistant IA",
    "edit": "Modifier l'assistant IA",
    "edit_popup": "Modifier l'assistant IA"
  },
  "ai-prompts-page": {
    "name": "Nom",
    "content": "Contenu",
    "actions": " ",
    "add": "Ajouter un prompt IA",
    "add_popup": "Ajouter un prompt IA",
    "delete": "Supprimer le prompt IA",
    "edit": "Modifier le prompt IA",
    "edit_popup": "Modifier le prompt IA",
    "key": "Clé du slot",
    "model": "Modèle",
    "updated_at": "Mis à jour",
    "custom": "Personnalisé",
    "description": "Description",
    "temperature": "Temperature",
    "top_p": "Top P",
    "reasoning_effort": "Effort de raisonnement",
    "reasoning_effort_default": "Par défaut",
    "required_placeholders": "Variables obligatoires (doivent être présentes dans le contenu)",
    "versions": "Historique des versions",
    "no_versions": "Aucune version pour le moment",
    "restore": "Restaurer",
    "restore_confirm": "Restaurer cette version ? Son contenu deviendra la version actuelle.",
    "restored": "Version restaurée",
    "current_version": "Actuelle",
    "author": "Auteur",
    "error": "Une erreur s'est produite.",
    "tab_system": "Système",
    "tab_custom": "Personnalisé",
    "system_hint": "Les prompts système sont utilisés par le code de la plateforme. Ils ne peuvent pas être supprimés, mais leur contenu peut être modifié.",
    "custom_hint": "Les prompts personnalisés sont rattachés aux compétences et aux profils IA en tant que remplacement du prompt d'évaluation.",
    "model_from_code": "défini par le code",
    "model_from_code_hint": "Le modèle est choisi par le code qui utilise le prompt ; il n'est pas stocké dans le prompt lui-même.",
    "used_by": "Utilisé par",
    "used_by_value": "Compétences : {competencies}, Profils IA : {profiles}",
    "not_used": "Non utilisé",
    "delete_blocked_hint": "Impossible de supprimer : le prompt est utilisé comme remplacement. {usage}",
    "slot_description": {
      "game_eval_negotiation": "Évaluation IA des sessions PvP : négociation",
      "game_eval_feedback": "Évaluation IA des sessions PvP : feedback",
      "game_eval_vs_ai": "Évaluation IA des sessions contre l'IA (si le profil IA n'a pas de remplacement)",
      "protocol_evaluation": "Remplissage du protocole du scénario à partir de la transcription d'une session contre l'IA",
      "voice_agent": "Prompt système de l'interlocuteur vocal IA",
      "scenario_generation": "Génération de scénario à partir d'une description",
      "scenario_card_update": "Mise à jour de la fiche du scénario à partir d'une description IA",
      "scenario_optimize": "Optimisation de la description IA d'un scénario",
      "skill_report_analysis": "Rapport de compétences : étape d'analyse",
      "skill_report_recommendations": "Rapport de compétences : étape de recommandations"
    }
  },
  "ai-profiles-page": {
    "name": "Nom",
    "settings": "Paramètres",
    "temperature": "Fantaisie",
    "demeanor": "Comportement",
    "behavior": "Comportement, instructions",
    "background": "Biographie",
    "style": "Style",
    "instructions": "Instructions",
    "supportive_phrases": "Phrases de soutien",
    "ai_assistant": "Assistant IA",
    "ai_starts_first": "L'IA commence en premier",
    "first_phrase": "Première phrase",
    "closing_phrases": "Phrases de clôture",
    "voice": "Voix",
    "expert_mode": "Mode expert",
    "custom_demeanor_hint": "Comportement personnalisé actuel",
    "is_shared": "Disponible pour toutes les entreprises",
    "voice_options": {
      "male": "Masculin",
      "female": "Féminin"
    },
    "demeanor_options": {
      "friendly": {
        "title": "Amical",
        "description": "Facilement abordable et agréable"
      },
      "critical": {
        "title": "Critique",
        "description": "Souligne fréquemment les défauts et les domaines d'amélioration"
      },
      "empathetic": {
        "title": "Empathique",
        "description": "Très sensible aux sentiments et émotions des autres"
      },
      "enthusiastic": {
        "title": "Enthousiaste",
        "description": "Montre une excitation et un empressement intenses"
      },
      "analytical": {
        "title": "Analytique",
        "description": "Se concentre sur la logique et la résolution détaillée de problèmes"
      },
      "curious": {
        "title": "Curieux",
        "description": "Désireux d'apprendre et de poser des questions"
      },
      "assertive": {
        "title": "Assertif",
        "description": "Confiant et sûr de soi"
      },
      "blunt": {
        "title": "Direct",
        "description": "Direct et va droit au but"
      },
      "skeptical": {
        "title": "Sceptique",
        "description": "Méfiant envers les nouvelles solutions et idées"
      },
      "neutral": {
        "title": "Neutre",
        "description": "Équilibré et objectif dans le style de communication"
      },
      "casual": {
        "title": "Décontracté",
        "description": "Détendu et conversationnel dans le ton"
      }
    },
    "placeholders": {
      "name": "Par exemple : Sergey (poli et amical)",
      "demeanor": "Par exemple : Amical, poli et sociable...",
      "background": "Par exemple : A été licencié deux fois...",
      "behavior": "Par exemple : N'interrompt pas, écoute activement...",
      "first_phrase": "Par exemple : Bonjour ! Comment allez-vous ?",
      "closing_phrases": "Par exemple : Il ne nous reste presque plus de temps, je propose donc de résumer rapidement notre réunion."
    },
    "actions": " ",
    "add": "Ajouter un profil IA",
    "add_popup": "Ajouter un profil IA",
    "subtitle": "L'apparence et la voix de l'interlocuteur pendant la session",
    "preview": {
      "title": "Aperçu",
      "unnamed": "Sans nom",
      "voice": "voix {name}",
      "defaultVoice": "voix par défaut",
      "defaultPhoto": "Photo par défaut",
      "listen": "Écouter la voix",
      "defaultVoiceNotice": "La voix sera choisie au début de la session — impossible de l'écouter à l'avance",
      "photoPlaceholder": "La photo apparaîtra ici"
    },
    "delete": "Supprimer le profil IA",
    "edit": "Modifier le profil IA",
    "edit_popup": "Modifier le profil IA",
    "avatar_hint": "image d'avatar",
    "avatar_save_first": "Enregistrez d'abord le profil pour activer l'envoi d'avatar",
    "avatar_requirements": "1 Mo max. • Recommandé : 1536×1024 • Format : 3:2",
    "max_characters": "{max} caractères maximum"
  },
  "games-page": {
    "game-with-ai": "Session avec IA",
    "organization": "Organisation",
    "status": "Statut",
    "failure_reasons": {
      "protocol_not_agreed": "Le protocole n'a pas été approuvé par les participants",
      "protocol_approval_expired": "Le délai d'approbation du protocole a expiré",
      "annulled": "La session a été annulée",
      "expired": "Le temps de la session a expiré",
      "assignment_changed": "L'attribution du cours a changé dans le système de formation"
    },
    "play": "Jouer",
    "meetings_unavailable": "Les sessions vidéo entre participants sont temporairement indisponibles. Veuillez réessayer plus tard.",
    "import": "Importer",
    "scenario": "Scénario",
    "tour": "Visite",
    "game_types": {
      "classic": "Mode classique",
      "vs_ai": "Session contre IA",
      "uploaded_recording": "Enregistrement"
    },
    "upload_recording": {
      "file": "Fichier d'enregistrement",
      "file_hint": "Vidéo ou audio, 1 Go max",
      "uploaded": "Fichier téléversé",
      "file_too_large": "Le fichier dépasse 1 Go",
      "upload_error": "Échec du téléversement du fichier",
      "player": "Participant",
      "rate_both": "Évaluer les deux participants",
      "second_player": "Deuxième participant",
      "open_session": "Ouvrir la session"
    },
    "game_targets": {
      "user": "Participant",
      "position": "Poste",
      "department": "Département"
    },
    "number": "Numéro",
    "start_up_to": "Commencer jusqu'à",
    "start_time": "Heure de début",
    "teamA": "Équipe A",
    "teamB": "Équipe B",
    "others": "Participants",
    "actions": " ",
    "edit_results": "Modifier les résultats",
    "add": "Ajouter une session",
    "add_popup": "Ajouter une session",
    "delete": "Supprimer la session",
    "edit": "Modifier la session",
    "edit_popup": "Modifier la session",
    "time_scheduling": "Planification du temps de début",
    "return_to_time_scheduling": "Revenir à la coordination de l'heure de début",
    "preparation": "Préparation pour la session",
    "view_scenario": "Voir le scénario",
    "protocol": "Approbation du protocole",
    "not_agreed": "Non convenu",
    "expert-accept": "Accepter et procéder à l'évaluation",
    "expert-decline": "Refuser",
    "hide_ai_results": "Masquer l'évaluation AI",
    "show_ai_results": "Afficher l'évaluation AI",
    "mark_failed": "Marquer comme échoué",
    "popup": {
      "start_up_to": "Commencer jusqu'à",
      "target": "À qui attribuer la session ?",
      "custom_field_value": "Valeur de « {field} »",
      "target_preview_count": "Sessions à créer : {count}",
      "target_preview_empty": "Aucun joueur ne correspond à ce segment — aucune session ne sera créée",
      "target_preview_limit_exceeded": "C'est plus que ce qu'une affectation peut créer (au maximum {limit}). Réduisez le segment, le nombre de cas ou le nombre de copies",
      "copies_per_player": "Copies de chaque cas par joueur",
      "position": "Poste",
      "department": "Département",
      "scenario": "Scénario",
      "optional": "Optionnel, peut être omis",
      "protocol_time": "Temps de protocole",
      "protocol_time_hint": "Nombre entre 1 et 1440",
      "preparation_time": "Temps de préparation",
      "preparation_time_hint": "En minutes",
      "game_duration": "Durée de la session",
      "game_duration_hint": "Nombre entre 1 et 60",
      "is_team": "Scénario pour équipes",
      "is_camera_required": "Les caméras des participants sont nécessaires",
      "is_self_rated": "Les participants peuvent s'évaluer",
      "is_each_other_rated": "Les participants peuvent s'évaluer entre eux",
      "is_expert_rated": "L'évaluation par un expert est disponible",
      "is_ai_rated": "L'évaluation par IA est disponible",
      "show_results": "Afficher les résultats",
      "automatically": "automatiquement",
      "manually": "manuellement",
      "is_public_hint": "Tout observateur pourra se connecter",
      "is_public": "Session publique",
      "team_a": "Équipe A",
      "team_b": "Équipe B",
      "player_a": "Participant A",
      "player_b": "Participant B",
      "expert": "Expert",
      "observers": "Observateurs",
      "tour": "Visite",
      "search": "Rechercher...",
      "choose_players": "Choisir les participants",
      "choose_expert": "Choisir un expert",
      "choose_observers": "Choisir des observateurs",
      "choose_scenario": "Choisir un scénario",
      "choose_tour": "Choisir une visite",
      "expert_empty": "Si non sélectionné, le capitaine pourra choisir",
      "captain": "Capitaine",
      "": "",
      "protocol": {
        "title": "Approbation du protocole",
        "target": "Cible",
        "await_approval": "Attendre l'approbation de l'adversaire",
        "await_proposal": "Attendre la proposition de l'adversaire",
        "questions": "Questions pour votre équipe",
        "questions_a": "Questions pour l'équipe A",
        "questions_b": "Questions pour l'équipe B",
        "not_agreed": "Pas d'accord",
        "not_agreed_confirm": "La session se terminera sans succès et les résultats ne seront pas comptabilisés. Cette action est irréversible.",
        "not_agreed_done": "La session s'est terminée sans succès."
      },
      "start_time": {
        "title": "Heure de début",
        "must_start_by": "Doit commencer par"
      },
      "edit_results": {
        "title": "Modifier les résultats"
      },
      "preparation": {
        "title": "Préparation pour la session",
        "description": "Description",
        "description_team": "Description de l'équipe",
        "notes": "Notes personnelles"
      },
      "import": {
        "download_example": "Télécharger l'exemple",
        "title": "Importation de sessions",
        "button": "Commencer l'importation",
        "label": "Fichier Excel"
      },
      "create_multi_scenario_games_immediately": "Toutes les sessions seront créées immédiatement",
      "create_multi_scenario_games_sequentially": "Les sessions seront créées séquentiellement (après la réussite de chacune)"
    }
  },
  "ai-game": {
    "title": "Session contre IA",
    "recording": "Enregistrement",
    "ai": "IA",
    "you": "Vous",
    "ai_ready": "Prêt",
    "camera_off": "La caméra est éteinte",
    "stop_game": "Arrêter la session",
    "start_game": "Commencer la session",
    "mic_permission": "Veuillez accorder les autorisations de microphone dans les paramètres pour commencer la session",
    "permissions_granted": "Autorisations accordées avec succès !",
    "close": "Fermer",
    "microphone_required": "Please grant microphone permissions to start the session",
    "mic_required": "Activez le microphone pour démarrer la session",
    "mic_not_detected": "Aucun son détecté pour l'instant — essayez de parler ou vérifiez votre microphone",
    "permissions_needed": "L'accès au microphone est requis. La caméra est facultative",
    "agent": {
      "initializing": "Initializing...",
      "listening": "Listening",
      "thinking": "Thinking...",
      "speaking": "Speaking",
      "waiting": "Waiting for agent..."
    },
    "waiting_for_start": "Start the session to begin conversation",
    "grant_microphone": "Grant Microphone Access",
    "game_not_found": "Session Not Found",
    "game_not_found_desc": "Session with ID {id} could not be located.",
    "confirm": {
      "start_question": "Êtes-vous sûr ? La session ne peut pas être mise en pause",
      "start_title": "Session commencée",
      "start_success": "La session a été démarrée avec succès",
      "start_cancel_title": "Session non démarrée",
      "start_cancel_msg": "Le démarrage de la session a été annulé",
      "end_question": "Êtes-vous sûr ? La session sera terminée",
      "end_title": "Session terminée",
      "end_success": "La session a été terminée avec succès",
      "end_cancel_title": "Session non terminée",
      "end_cancel_msg": "La fin de la session a été annulée"
    },
    "voice": {
      "disconnected": "Déconnecté",
      "connecting": "Connexion en cours...",
      "connected": "Connecté au serveur",
      "connection_error": "Échec de la connexion à l'agent vocal",
      "game_already_finished": "Cette partie est déjà terminée",
      "connection_timeout": "Connection to voice server timed out. This may be caused by a firewall or network restrictions. Check your network settings and try again.",
      "no_rooms_available": "Aucune salle disponible pour le moment. Veuillez réessayer plus tard.",
      "preparing_recording": "Préparation de l'enregistrement, nouvelle tentative dans {seconds}s…",
      "recording_service_overloaded": "Le service d'enregistrement est surchargé. Veuillez réessayer dans quelques minutes.",
      "session_quota_exhausted": "Le forfait de sessions de votre organisation est épuisé. Veuillez contacter votre responsable.",
      "connection_blocked": "Votre réseau a bloqué l'établissement de la connexion avec l'IA. Autorisez le HTTPS (443) vers les domaines nécessaires, puis réessayez.",
      "connection_blocked_signaling": "Le pare-feu ou le proxy de votre réseau bloque la connexion au serveur vocal. Essayez de vous connecter depuis un autre réseau ou un point d'accès mobile.",
      "reconnecting": "Reconnecting...",
      "disconnect_dialog_title": "Connection Lost",
      "disconnect_dialog_message": "The connection was interrupted. Would you like to reconnect or finish the session?",
      "disconnect_retry": "Reconnect",
      "disconnect_finish": "Finish Session",
      "agent_join_timeout": "The AI agent did not connect in time. Please try again.",
      "stop_failed": "Failed to stop the session",
      "mic_enable_failed": "Microphone could not be enabled. You can try toggling it manually.",
      "mic_toggle_failed": "Failed to toggle microphone",
      "camera_toggle_failed": "Failed to toggle camera",
      "duplicate_tab_title": "Session Open in Another Tab",
      "duplicate_tab_message": "This session is already active in another browser tab. Close the other tab and reopen this page if you want to continue here.",
      "duplicate_tab_back": "Go Back",
      "duplicate_tab_disconnect_title": "Opened in Another Tab",
      "duplicate_tab_disconnect_message": "This tab was disconnected because the session is already active in another tab. Return to the session page from here."
    },
    "permissions_denied_safari": "L'accès à la caméra ou au microphone a été refusé. Allez dans Réglages Safari > Sites web > Caméra/Microphone et autorisez l'accès pour ce site.",
    "supported": "Navigateur pris en charge"
  },
  "positions-page": {
    "title": "Titre",
    "actions": " ",
    "add": "Ajouter un poste",
    "add_popup": "Ajouter un poste",
    "delete": "Supprimer le poste",
    "edit": "Modifier le poste",
    "edit_popup": "Modifier le poste"
  },
  "user-custom-fields-page": {
    "title": "Titre",
    "type": "Type",
    "options_count": "Valeurs",
    "actions": " ",
    "add": "Ajouter un champ",
    "add_popup": "Ajouter un champ",
    "delete": "Supprimer le champ",
    "delete_confirm": "Supprimer le champ ? Les valeurs enregistrées pour les utilisateurs ne seront plus affichées.",
    "edit": "Modifier le champ",
    "edit_popup": "Modifier le champ",
    "empty": "Aucun champ personnalisé pour le moment",
    "error": "Échec de l'enregistrement du champ",
    "type_text": "Texte",
    "type_select": "Liste de choix",
    "type_locked_hint": "Le type ne peut pas être modifié après la création du champ",
    "options": "Valeurs",
    "options_hint": "L'ordre des valeurs ici correspond à l'ordre dans la liste déroulante",
    "options_required": "Ajoutez au moins une valeur",
    "option_title": "Valeur",
    "option_add": "Ajouter une valeur",
    "option_delete": "Supprimer la valeur",
    "option_delete_confirm": "Supprimer la valeur ? Elle sera effacée pour les utilisateurs qui l'avaient sélectionnée.",
    "option_move_up": "Déplacer vers le haut",
    "option_move_down": "Déplacer vers le bas"
  },
  "organizations-page": {
    "name": "Nom",
    "host": "Hôte",
    "duel_limit": "Limite de duel",
    "max_users": "Max. utilisateurs",
    "max_users_hint": "0 = illimité",
    "max_vs_ai_games_per_scenario": "Max. parties IA par joueur et par scénario",
    "max_vs_ai_games_per_scenario_hint": "Vide = pas de limite. S'applique à la création de parties en autonomie par le joueur",
    "employee_report_daily_limit": "Limite de rapports des employés par jour",
    "employee_report_daily_limit_hint": "Vide = limite de la plateforme. S'applique aux gestionnaires et responsables",
    "employee_report_hourly_limit": "Limite de rapports des employés par heure",
    "employee_report_hourly_limit_hint": "Vide = limite de la plateforme. S'applique aux gestionnaires et responsables",
    "registration": "Inscription ouverte",
    "timezone": "Fuseau horaire",
    "locale": "Locale",
    "users_count": "Utilisateurs",
    "actions": " ",
    "add": "Ajouter une organisation",
    "add_popup": "Ajouter une organisation",
    "delete": "Supprimer l'organisation",
    "edit": "Modifier l'organisation",
    "edit_popup": "Modifier l'organisation",
    "available_languages": "Langues disponibles",
    "show_game_numbers_for_player": "Afficher les numéros de session pour le participant",
    "allow_players_choose_expert": "Permettre aux participants de choisir un expert",
    "send_message": "Envoyer un message aux managers",
    "message": "Message",
    "send": "Envoyer",
    "clear_message": "Effacer le message",
    "current_message": "Message actuel",
    "two_factor_method": "Authentification à deux facteurs",
    "two_factor_disabled": "Désactivée",
    "two_factor_email": "E-mail",
    "two_factor_sms": "SMS",
    "hidden_menu_items": "Hidden menu items",
    "hide_ai_results": "Masquer les résultats de l'IA",
    "hide_player_rating": "Masquer le classement de l'entreprise aux participants",
    "show_character_memory_to_player": "Afficher la mémoire du personnage au joueur",
    "show_meeting_recap_to_player": "Afficher le résumé de la rencontre au joueur",
    "create_user_on_external_launch": "Créer un utilisateur dès la première requête d'un système externe",
    "create_user_on_external_launch_hint": "Si elle est désactivée, un apprenant que le système externe n'a encore jamais amené est refusé au lieu d'obtenir une partie. Chaque utilisateur créé de cette façon occupe une place dans l'abonnement.",
    "allow_external_email_linking": "Permettre de lier un utilisateur externe par email",
    "allow_external_email_linking_hint": "Si elle est activée, une personne externe est associée à un employé déjà existant lorsque le système externe a transmis son adresse email depuis son propre serveur. Si elle est désactivée, un tel lancement est refusé et aucun second utilisateur avec cette adresse n'est créé."
  },
  "users-page": {
    "import": "Importer",
    "user": "Utilisateur",
    "roles": "Rôles",
    "effectiveness": "Efficacité",
    "department": "Département",
    "position": "Position",
    "status": "Statut",
    "actions": " ",
    "add": "Ajouter un utilisateur",
    "add_popup": "Nouvel utilisateur",
    "last_login_at": "Dernière connexion",
    "delete": "Supprimer",
    "view": "Afficher",
    "login": "Connexion",
    "message": "Message",
    "activate": "Activer",
    "deactivate": "Bloquer",
    "edit_popup": "Modifier l'utilisateur",
    "total_in_org": "Total dans l'organisation",
    "multi_role_note": "Un utilisateur avec plusieurs rôles est compté dans chaque badge",
    "filter_role": "Rôle",
    "all_roles": "Tous les rôles",
    "filter_activity": "Scénarios réalisés",
    "activity_played": "Oui",
    "activity_not_played": "Non",
    "filter_activity_from": "Joué depuis",
    "filter_last_login_from": "Date de connexion",
    "filter_custom_field": "Champ personnalisé",
    "filter_custom_field_value": "Valeur de « {field} »",
    "last_login_never": "Jamais connecté",
    "last_login_since": "Connecté depuis",
    "cases_progress": "Cas terminés",
    "cases_progress_value": "{completed} sur {assigned}",
    "export": "Exporter",
    "popup": {
      "name": "Prénom",
      "last_name": "Nom",
      "patronymic": "Patronyme",
      "phone": "Téléphone",
      "timezone": "Fuseau horaire",
      "language": "Langue",
      "country": "Pays",
      "invalid_phone": "Numéro de téléphone invalide",
      "department": "Département",
      "position": "Position",
      "effectiveness": "Efficacité",
      "roles": "Rôles",
      "organizations": "Entreprises",
      "blocked": "Bloqué",
      "is_active": "Est actif",
      "email_verified": "L'email est vérifié",
      "email_not_verified": "L'email n'est pas vérifié",
      "subordinates": "Subordonnés",
      "search_subordinates": "Rechercher des participants...",
      "import": {
        "download_example": "Télécharger l'exemple",
        "title": "Importation d'utilisateurs",
        "button": "Commencer l'importation",
        "label": "Fichier Excel",
        "marker_hint": "Pour un utilisateur déjà existant, une cellule vide conserve la valeur actuelle et un tiret (-) efface le champ.",
        "result_title": "Importation lancée",
        "result_created": "Seront créés : {count}",
        "result_updated": "Seront mis à jour : {count}",
        "result_skipped": "Ignorées : {count}",
        "result_skipped_row": "Ligne {row}, {email} : {reason}",
        "result_truncated": "… et {count} lignes ignorées supplémentaires"
      }
    }
  },
  "users-ranking-page": {
    "user": "Utilisateur",
    "roles": "Rôles",
    "effectiveness": "Efficacité",
    "average-effectiveness": "Moyenne par session",
    "sessions-count": "Sessions",
    "department": "Département",
    "position": "Poste",
    "status": "Statut",
    "export": "Exporter",
    "actions": " "
  },
  "user-detail": {
    "games_finished": "Sessions terminées",
    "not_found": "Utilisateur non trouvé",
    "games_total": "Total",
    "username": "Nom d'utilisateur",
    "phone": "Téléphone",
    "status": "Statut",
    "language": "Langue",
    "timezone": "Fuseau horaire",
    "edit": "Modifier",
    "department": "Département",
    "position": "Position",
    "activate": "Activer",
    "block": "Bloquer",
    "account": {
      "title": "Compte",
      "summary": {
        "title": "Résumé",
        "games": "Sessions jouées",
        "place": "Lieu",
        "effectiveness": "Efficacité",
        "time": "Temps"
      }
    },
    "security": {
      "title": "Sécurité",
      "change_password_title": "Changer le mot de passe",
      "change_password": "Changer le mot de passe",
      "new_password": "Nouveau mot de passe",
      "confirm_new_password": "Confirmer le nouveau mot de passe",
      "password_requirements": "Exigences de mot de passe :",
      "password_requirements_1": "Minimum 8 caractères - plus c'est long, mieux c'est",
      "password_requirements_2": "Au moins un caractère minuscule",
      "password_requirements_3": "Au moins un nombre, un symbole ou un espace"
    },
    "statistics": {
      "title": "Statistiques"
    }
  },
  "game": {
    "character_memory": {
      "title": "Ce dont le personnage se souvient",
      "subtitle": "La mémoire des rencontres passées que le personnage apporte à cette partie",
      "preview_subtitle": "La mémoire n’est pas encore figée : le personnage la reçoit au moment où la partie commence",
      "unavailable": "La rencontre précédente n’est pas accessible au personnage : il commencera la conversation sans s’en souvenir.",
      "agreements": "Accords",
      "player_commitments": "Engagements du joueur",
      "character_commitments": "Engagements du personnage",
      "open_issues": "Questions en suspens",
      "facts": "Faits mentionnés",
      "attitude": "Attitude envers le joueur",
      "evaluation_passed": "Les résultats de l’évaluation de cette rencontre ont été transmis au personnage",
      "evaluation_not_ready": "L’évaluation de cette rencontre n’est pas encore prête : le personnage la recevra une fois qu’elle aura été calculée.",
      "evaluation_hidden": "Les textes de l’évaluation sont masqués par les paramètres de l’organisation.",
      "overall_effectiveness": "Efficacité globale",
      "outcome": {
        "deal": "Accord",
        "partial": "Partiel",
        "no_deal": "Pas d’accord",
        "unclear": "Incertain"
      }
    },
    "meeting_recap": {
      "title": "Résumé de la rencontre",
      "outcome": "Résultat de la rencontre",
      "agreements": "Accords",
      "player_commitments": "Engagements du joueur",
      "character_commitments": "Engagements du personnage",
      "open_issues": "Questions en suspens",
      "facts": "Faits mentionnés",
      "pending": "Le résumé de la rencontre est encore en préparation. Revenez un peu plus tard.",
      "unavailable": "Le résumé de cette rencontre n’a pas pu être établi.",
      "none": "Il n’y a pas de résumé pour cette partie."
    },
    "title": "Session",
    "team": "Équipe",
    "expert": "Expert",
    "points": "points",
    "your_result": "Votre résultat",
    "joined_at": "Rejoint le :",
    "ended_at": "Date de fin",
    "min": "min.",
    "duration": "Durée",
    "from_average": "de la moyenne",
    "ai_expert": "Expert IA",
    "ai_evaluation_in_progress": "Évaluation IA en cours",
    "delete_ai_request": "Supprimer l'évaluation IA",
    "ai_expert_refresh": "Rafraîchir les résultats IA",
    "ai_expert_refresh_rejected": {
      "evaluation_not_completed": "Les résultats IA ne peuvent pas être rafraîchis pour le moment : l'évaluation IA est encore en cours.",
      "answer_pending": "Les résultats IA ne peuvent pas être rafraîchis pour le moment : la réponse de l'IA n'est pas encore arrivée.",
      "recognition_pending": "Les résultats IA ne peuvent pas être rafraîchis pour le moment : l'enregistrement est encore en cours de transcription.",
      "recognition_has_no_speech": "Aucune parole n'a été reconnue dans l'enregistrement : les résultats IA ne peuvent pas être rafraîchis.",
      "recognition_has_too_little_speech": "Il n'y a presque aucune conversation entre les participants dans l'enregistrement : l'évaluation IA n'a pas été effectuée.",
      "no_ai_evaluation": "Cette session n'a plus d'évaluation IA.",
      "game_evaluation_blocked": "La session n'a pas eu lieu ou a été annulée, l'évaluation IA n'est donc pas disponible."
    },
    "ai_expert_unavailable": {
      "recognition_has_no_speech": "Aucune parole n'a été reconnue dans l'enregistrement : l'évaluation IA n'a pas été effectuée.",
      "recognition_has_too_little_speech": "Il n'y a presque aucune conversation entre les participants dans l'enregistrement : l'évaluation IA n'a pas été effectuée.",
      "game_evaluation_blocked": "La session n'a pas eu lieu ou a été annulée, l'évaluation IA n'est donc pas disponible."
    },
    "ai_expert_refresh_failed": "Échec du rafraîchissement des résultats IA.",
    "speaker_mapping": {
      "title": "Participants et voix",
      "voice": "Voix {number}",
      "unknown": "Non identifié",
      "needs_review": "Vérifiez les participants",
      "needs_review_hint": "Les participants ont peut-être été mal identifiés : assurez-vous que l'évaluation IA est allée aux bonnes personnes.",
      "failed": "Les participants n'ont pas pu être identifiés automatiquement.",
      "unavailable": "Le fournisseur IA était indisponible ; les participants seront identifiés lors de la prochaine évaluation.",
      "empty": "La transcription ne contient aucune réplique permettant d'identifier les participants.",
      "corrected_manually": "Corrigé manuellement",
      "under_reevaluation": "L'évaluation IA est en cours avec ces participants. Jusqu'à ce qu'elle se termine, la page affiche les résultats précédents.",
      "confirm": "Les participants sont corrects",
      "review": "Vérifier",
      "dialog_hint": "Attribuez un participant à chaque voix. Une fois enregistré, l'évaluation IA sera redemandée.",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "confirmed": "Participants confirmés",
      "fixed": "Participants corrigés, évaluation IA redemandée",
      "action_failed": "Impossible d'effectuer l'action"
    },
    "ai_expert_created": "Le processus d'évaluation de la session a commencé. Cela prendra quelques minutes. Vous pouvez quitter la page, car nous vous enverrons une notification lorsque l'évaluation sera disponible.",
    "expert_already_requested": "L'évaluation a déjà été demandée par un autre participant",
    "request_expert": "Demander un expert",
    "assign_expert": "Attribuer un expert",
    "ai_process": "Veuillez patienter, traitement",
    "analyzing_results": "Analyse des résultats de la session...",
    "complete_expert_request": "Évaluation complète",
    "tabs": {
      "description": {
        "title": "Description du Scénario",
        "subtitle": "Informations et règles de la session",
        "situation": "Situation",
        "your_role": "Votre rôle",
        "player_role": "Rôle du joueur : {name}",
        "team_tab": "Équipe {team}",
        "empty": "Cette session n'a aucune description.",
        "load_error": "Impossible de charger la description. Veuillez réessayer plus tard."
      },
      "results": {
        "title": "Résultats",
        "effectiveness_summary": "Efficacité de l'équipe",
        "your_effectiveness": "Votre efficacité",
        "parameters_section": "Paramètres",
        "parameter": "Paramètre",
        "target": "Cible",
        "coefficient": "Coefficient",
        "value": "Accord",
        "points": "Points",
        "points_short": "points",
        "combinations": "Combinaisons",
        "combination_bonus": "Bonus de combinaison",
        "questions": "Questions",
        "question": "Question",
        "answer": "Réponse",
        "total": "Total"
      },
      "comments": {
        "title": "Analyse vidéo",
        "comments": "Commentaires",
        "no_comments": "Pas encore de commentaires",
        "no_video": "Vidéo non disponible",
        "video_processing": "La vidéo est en cours de traitement...",
        "count": "commentaires",
        "delete": "Supprimer",
        "edit": "Modifier",
        "popup": {
          "add": "Ajouter un commentaire",
          "edit": "Modifier le commentaire",
          "comment": "Commentaire",
          "player": "Participant",
          "all": "À tous"
        }
      },
      "feedback": {
        "title": "Évaluation de la session",
        "no_feedback": "Pas encore d'évaluations",
        "no_feedback_description": "Le feedback pour cette session n'a pas encore été ajouté",
        "overall_score": "Score Global",
        "skills_evaluated": "{count} compétences évaluées",
        "no_comment": "Aucun commentaire fourni",
        "score_button": "Évaluer le participant",
        "player": "Participant",
        "author": "Auteur",
        "download": "Télécharger la vidéo",
        "download_transcript": "Télécharger la transcription",
        "evaluators": {
          "ai": "Expert",
          "expert": "Expert",
          "player": "Participant",
          "manager": "Gestionnaire",
          "head": "Responsable"
        },
        "popup": {
          "score": {
            "title": "Évaluation du participant",
            "comment": "Commentaire",
            "error": "Vous devez évaluer toutes les compétences du participant",
            "save_error": "Impossible d'enregistrer l'évaluation. Vous n'avez peut-être pas l'autorisation d'évaluer ce participant."
          }
        }
      },
      "checklist": {
        "title": "Liste de contrôle",
        "total": "Éléments réussis",
        "pass": "Réussi",
        "fail": "Échoué",
        "cannot_assess": "Non évaluable",
        "comment": "Commentaire général",
        "category": "Catégorie",
        "author": "Évaluateur",
        "player": "Participant",
        "passed_of": "{passed} sur {total}",
        "evidence": "Preuve",
        "rationale": "Justification",
        "no_results": "Pas encore d'évaluation par liste de contrôle",
        "no_results_description": "Cette session n'a pas encore été évaluée avec une liste de contrôle"
      }
    }
  },
  "scenario": {
    "steps": {
      "information": {
        "create_new_ai_profile": "Créer nouveau",
        "edit_ai_profile": "Modifier",
        "delete_ai_profile": "Supprimer",
        "confirm_delete_ai_profile": "Êtes-vous sûr de vouloir supprimer ce profil IA ?",
        "first_header": "Paramètres de Base",
        "second_header": "Participant IA",
        "third_header": "Description du Scénario",
        "is_public": "Public",
        "is_public_hint": "Si activé — le scénario sera disponible pour la sélection par les participants.",
        "title": "Information",
        "subtitle": "Données de base du scénario",
        "image": "image du scénario",
        "field_title": "Titre",
        "competence": "Compétence",
        "description": "Description",
        "description_a": "Description pour l'équipe A",
        "description_b": "Description pour l'équipe B",
        "next_scenario_label": "Scénario Suivant",
        "next_scenario_placeholder": "Non sélectionné",
        "next_scenario_hint": "Après avoir terminé la session avec ce scénario, une session avec le scénario suivant sera automatiquement créée.",
        "memory_header": "Lien vers la prochaine rencontre",
        "memory_group_evaluation": "L’évaluation de la prochaine rencontre",
        "memory_group_character": "Le personnage de la prochaine rencontre",
        "memory_pass_to_next": "se souvient de cette rencontre",
        "memory_pass_to_next_hint": "Le personnage du scénario suivant engage la conversation comme avec une personne qu’il connaît déjà : il reçoit un bref résumé de cette rencontre, les accords conclus, les engagements des deux parties, les questions en suspens et les faits mentionnés. L’enregistrement et les citations mot pour mot ne lui sont pas transmis. Activez cette option lorsque la prochaine rencontre fait suite à celle-ci : un second tour de négociations, un entretien individuel récurrent.",
        "memory_pass_evaluation_to_next": "connaît l’évaluation de cette rencontre",
        "memory_pass_evaluation_to_next_hint": "Avec la mémoire, le personnage reçoit les textes de retour sur les compétences ainsi que le résultat global de cette rencontre, ce qui lui permet d’agir comme un coach qui se souvient de ce que le joueur a réussi.",
        "memory_evaluate_next_with_agreements": "tient compte des accords de cette rencontre",
        "memory_evaluate_next_with_agreements_hint": "Lors de l’évaluation de la prochaine rencontre, l’expert IA voit les accords, les engagements des deux parties et les questions en suspens de celle-ci, et peut vérifier si le joueur a tenu parole. Les notes et les textes d’évaluation de la rencontre précédente ne sont pas transmis, afin qu’ils n’influencent pas la nouvelle note.",
        "ai_profile": "Profil IA",
        "ai_profile_placeholder": "Pour les matchs IA uniquement",
        "ai_description": "Description IA",
        "optimize_ai_description": "Optimize with AI",
        "optimizing_in_progress": "AI is optimizing the description. Please wait...",
        "optimize_error": "Failed to optimize the description. Please try again.",
        "ai_description_hint": "La rédaction d'un prompt IA efficace nécessite de l'expérience. Un prompt mal rédigé peut entraîner un comportement imprévisible du scénario. En cas de doute, utilisez le bouton « Optimiser avec l'IA », essayez la génération de scénarios ou contactez votre responsable.",
        "knowledge_base_header": "Base de connaissances",
        "knowledge_base_documents": "Documents de la base de connaissances",
        "knowledge_base_documents_hint": "Associez des documents pour fournir du contexte au joueur IA",
        "knowledge_base_no_documents": "Aucun document disponible. Téléchargez des documents sur la page \"Base de connaissances\".",
        "knowledge_base_chunks": "{count} fragments",
        "knowledge_base_purpose_voice": "Session IA",
        "knowledge_base_purpose_eval": "Évaluation"
      },
      "settings": {
        "title": "Paramètres",
        "subtitle": "Configuration du scénario",
        "min_players": "Participants min",
        "min_players_hint": "Nombre entre 2 et 20",
        "max_players": "Participants max",
        "max_players_hint": "Nombre entre 2 et 20",
        "protocol_time": "Temps de protocole (min)",
        "protocol_time_hint": "Nombre entre 1 et 1440",
        "preparation_time": "Temps de préparation (min)",
        "preparation_time_hint": "Nombre entre 0 et 1440. 0 - la description est immédiatement visible",
        "game_duration": "Durée de la session (min)",
        "game_duration_hint": "Nombre entre 1 et 60",
        "is_team": "Scénario pour équipes",
        "is_camera_required": "Les caméras des participants sont nécessaires",
        "is_self_rated": "Les participants peuvent s'évaluer",
        "is_each_other_rated": "Les participants peuvent s'évaluer entre eux",
        "is_expert_rated": "L'évaluation par un expert est disponible",
        "is_ai_rated": "L'évaluation par IA est disponible",
        "show_results": "Afficher les résultats",
        "automatically": "automatiquement",
        "manually": "manuellement"
      },
      "parameters": {
        "title": "Paramètres",
        "subtitle": "Paramètres du participant",
        "field_title": "Titre",
        "team_a": "Équipe A",
        "team_b": "Équipe B",
        "player_a": "Participant A",
        "player_b": "Participant B",
        "points": "Points",
        "ratio": "Ratio",
        "add": "Ajouter un paramètre"
      },
      "questions": {
        "title": "Questions",
        "subtitle": "Questions pour les participants",
        "question": "Question",
        "team": "Équipe",
        "team_placeholder": "Sélectionnez l'équipe",
        "answers": "Réponses",
        "points": "Points",
        "select_answers": "Sélectionner les réponses",
        "add_combination": "Ajouter une combinaison",
        "add_question": "Ajouter une question"
      },
      "next": "Suivant",
      "previous": "Précédent",
      "save": "Enregistrer"
    },
    "saved": "Scénario enregistré",
    "to_list": "Retour à la liste",
    "add_detail": "Ajouter un scénario",
    "edit_detail": "Modifier un scénario"
  },
  "notifications": {
    "title": "Notifications",
    "mark_unread": "Marquer tout comme non lu",
    "mark_read": "Marquer tout comme lu",
    "delete_all": "Tout supprimer",
    "no_new": "Aucune notification trouvée",
    "system": "Système",
    "evaluation": {
      "ready": {
        "subject": "Évaluation de la session #:gameNumber",
        "text": "La session a été évaluée par un expert"
      }
    },
    "game": {
      "created": {
        "game_assigned": "Vous avez une session assignée",
        "role": "Rôle :"
      },
      "proposal": {
        "subject": "Coordination de l'heure de la session",
        "time": "Heure :",
        "description": "Veuillez confirmer ou proposer votre propre option"
      },
      "agreed": {
        "subject": "Heure de la session convenue",
        "time": "Heure :",
        "description": "La description et les options de préparation seront disponibles :preparationTime minutes avant le début",
        "description_zero": "Vous pouvez maintenant revoir la description du scénario et vous préparer"
      },
      "preparation": {
        "subject": "Préparation pour la session",
        "text": "La préparation de la session est disponible."
      },
      "started": {
        "subject": "La session #:gameNumber a commencé",
        "text": "Rejoignez !"
      },
      "missed": {
        "subject": "La session #:gameNumber est manquée",
        "text": "Désolé, vous avez manqué la session"
      },
      "completed": {
        "subject": "Session #:gameNumber terminée",
        "text": "Session réussie"
      },
      "failed": {
        "subject": "Session #:gameNumber échouée",
        "text": "Terminé sans succès"
      },
      "results": {
        "proposed": {
          "subject": "Protocole de session #:gameNumber convenu",
          "text": "Accord disponible"
        },
        "declined": {
          "subject": "Protocole de session #:gameNumber rejeté",
          "text": "Proposition rejetée"
        },
        "not_agreed": {
          "subject": "Session #:gameNumber : les parties ne se sont pas mises d'accord",
          "text": "Le capitaine adverse a indiqué que les parties ne se sont pas mises d'accord. La session s'est terminée sans succès et les résultats n'ont pas été comptabilisés."
        }
      },
      "meeting": {
        "ended-player": {
          "subject": "Réunion de session #:gameNumber terminée",
          "text": "Veuillez attendre les résultats."
        },
        "ended-captain": {
          "subject": "Réunion de session #:gameNumber terminée",
          "text_fill": "Veuillez remplir le protocole.",
          "text_wait": "Veuillez attendre que le protocole soit complété.",
          "protocol_time": "Temps de protocole (minutes) : :protocolTime"
        }
      }
    }
  },
  "profile": {
    "avatar_allowed": "JPG, GIF ou PNG autorisés. Taille max de 2MB",
    "avatar_label_choose": "Choisir",
    "avatar_label_your_avatar": "votre avatar",
    "name": "Prénom",
    "last_name": "Nom",
    "patronymic": "Patronyme",
    "phone": "Téléphone",
    "timezone": "Fuseau horaire",
    "language": "Langue",
    "country": "Pays",
    "invalid_phone": "Numéro de téléphone invalide",
    "save_changes": "Sauvegarder les modifications",
    "account": "Compte",
    "security": "Sécurité",
    "statistics": "Statistiques",
    "notifications": "Notifications",
    "change_password_title": "Changer le mot de passe",
    "change_password": "Changer le mot de passe",
    "current_password": "Mot de passe actuel",
    "new_password": "Nouveau mot de passe",
    "confirm_new_password": "Confirmez le nouveau mot de passe",
    "password_requirements": "Exigences de mot de passe :",
    "password_requirements_1": "Minimum 8 caractères - le plus c'est long, mieux c'est",
    "password_requirements_2": "Au moins un caractère minuscule",
    "password_requirements_3": "Au moins un nombre, un symbole ou un espace",
    "two_factor_title": "Authentification à deux facteurs",
    "two_factor_description": "Ajoutez une couche de sécurité supplémentaire à votre compte",
    "two_factor_org_enforced": "L'authentification à deux facteurs est imposée par votre organisation",
    "two_factor_method": "Méthode d'authentification",
    "two_factor_disabled": "Désactivée",
    "two_factor_email": "E-mail",
    "two_factor_sms": "SMS",
    "two_factor_save": "Enregistrer les paramètres 2FA"
  },
  "auth": {
    "password": "Mot de passe",
    "new_password": "Nouveau mot de passe",
    "remember": "Souviens-toi de moi",
    "timezone": "Fuseau horaire",
    "forgot": "Mot de passe oublié",
    "login": "Connexion",
    "login_title": "Connexion",
    "new_password_title": "Changer le mot de passe",
    "change_password": "Sauvegarder",
    "country": "Pays",
    "invalid_phone": "Numéro de téléphone invalide",
    "privacy_policy_title": "Politique de confidentialité",
    "privacy_policy_text": "Texte de la politique de confidentialité...",
    "first_time": "Nouveau sur notre plateforme ?",
    "registration": "Créer un compte",
    "forgot_title": "Mot de passe oublié ?",
    "forgot_description": "Entrez votre email et nous vous enverrons les instructions pour réinitialiser votre mot de passe",
    "send_reset_link": "Envoyer le lien de réinitialisation",
    "back_to_login": "Retour à la connexion",
    "register": "S'inscrire",
    "name": "Prénom",
    "last_name": "Nom de famille",
    "patronymic": "Patronymique",
    "phone": "Téléphone",
    "enter_password": "Entrez le mot de passe",
    "confirm_password": "Confirmez le mot de passe",
    "not_first_time": "Vous avez déjà un compte ?",
    "agree_too": "J'accepte",
    "privacy_policy": "la politique de confidentialité & les conditions",
    "accept": " J'accepte ",
    "password_validation": "Le champ doit contenir au moins une majuscule, une minuscule, un caractère spécial et un chiffre avec un minimum de 8 caractères",
    "password_confirm_error": "La confirmation du mot de passe ne correspond pas",
    "set_password": "Définir un nouveau mot de passe",
    "reset_password": "Réinitialiser le mot de passe",
    "for": "pour",
    "sign_in_to_for": "Connexion à {app} pour {org}",
    "registration_title": "Inscription",
    "verify_title": "Confirmation de l'email",
    "verify_head": "Vérifiez votre email",
    "verify_description": "Lien d'activation du compte envoyé à votre adresse email. Veuillez suivre le lien pour continuer.",
    "verify_new_link": "Un nouveau lien de vérification a été envoyé à l'adresse email que vous avez fournie lors de l'inscription.",
    "verify_send": "Renvoyer l'email de vérification",
    "verify_spam": "Vous avez fait trop de demandes, veuillez réessayer dans une minute",
    "verify_logout": "Déconnexion",
    "two_factor_title": "Authentification à deux facteurs",
    "two_factor_description_email": "Nous avons envoyé un code de vérification à votre adresse e-mail. Veuillez entrer le code ci-dessous.",
    "two_factor_description_sms": "Nous avons envoyé un code de vérification à votre numéro de téléphone. Veuillez entrer le code ci-dessous.",
    "two_factor_code_label": "Code de vérification",
    "two_factor_code_placeholder": "Entrez le code à 6 chiffres",
    "two_factor_verify": "Vérifier",
    "two_factor_resend": "Renvoyer le code",
    "two_factor_resend_success": "Un nouveau code a été envoyé",
    "two_factor_back": "Retour à la connexion"
  },
  "filepond": {
    "upload": "Téléverser",
    "upload_complete": "Téléversement terminé",
    "uploading": "Téléversement en cours",
    "loading": "Chargement",
    "tap_to_cancel": "touchez pour annuler",
    "tap_to_undo": "touchez pour annuler",
    "upload_aborted": "Téléversement annulé",
    "file_too_large": "Le fichier est trop volumineux"
  },
  "text-editor": {
    "image": "Simply drag and drop your image in editor"
  },
  "webrtc": {
    "ready_to_start": "Prêt à démarrer",
    "connected": "Connecté - Parlez maintenant !",
    "connection_lost": "Connexion perdue. Veuillez réessayer."
  },
  "device_settings": {
    "title": "Paramètres des périphériques audio et vidéo",
    "speaker": "Haut-parleur/Sortie audio",
    "refresh_devices": "Actualiser les périphériques",
    "speaker_switch_unsupported": "Le changement de haut-parleur n'est pas pris en charge dans ce navigateur"
  },
  "device_setup": {
    "mic_level": "Niveau du micro",
    "mic_on": "Act",
    "mic_off": "Dés",
    "cam_on": "Act",
    "cam_off": "Dés"
  },
  "device_test": {
    "title": "Tester les périphériques audio",
    "speaker_test": "Test du haut-parleur",
    "speaker_hint": "Cliquez sur le bouton pour jouer des sons de test via le haut-parleur sélectionné",
    "play_sound": "Jouer le son test",
    "playing": "Lecture en cours...",
    "speaker_success": "Son joué ✓",
    "mic_test": "Test du microphone",
    "mic_hint": "Cliquez sur le bouton et parlez dans votre microphone pour vérifier s'il fonctionne",
    "volume_level": "Niveau du volume",
    "speak_now": "Parlez maintenant...",
    "seconds_short": "s",
    "start_mic_test": "Tester le microphone",
    "testing": "Test en cours...",
    "test_again": "Tester à nouveau",
    "mic_success": "Le microphone fonctionne correctement !",
    "mic_fail": "Problème de microphone détecté",
    "mic_fail_hint": "Aucun son détecté. Veuillez vérifier que votre microphone est connecté, non muet et correctement sélectionné dans les paramètres."
  },
  "ai_assistant_types": {
    "type": "Type",
    "negotiation": "Négociation",
    "feedback": "Retour d'information",
    "ai_profile": "Session avec IA"
  },
  "Login": "Connexion",
  "UI Elements": "Éléments UI",
  "Forms & Tables": "Formulaires & Tableaux",
  "Welcome": "Bienvenue",
  "Pages": "Pages",
  "Charts & Maps": "Graphiques & Cartes",
  "Others": "Autres",
  "Typography": "Typographie",
  "Cards": "Cartes",
  "Basic": "De base",
  "Advance": "Avancé",
  "Widgets": "Widgets",
  "Components": "Composants",
  "Alert": "Alerte",
  "Close Alert": "Fermer l'alerte",
  "Avatar": "Avatar",
  "Badge": "Badge",
  "Button": "Bouton",
  "Calendar": "Calendrier",
  "Image": "Image",
  "Pagination": "Pagination",
  "Progress Circular": "Progression Circulaire",
  "Progress Linear": "Progression Linéaire",
  "Autocomplete": "Autocomplète",
  "Tooltip": "Info-bulle",
  "Slider": "Curseur",
  "Date Time Picker": "Sélecteur de Date et Heure",
  "Select": "Sélectionner",
  "Switch": "Interrupteur",
  "Checkbox": "Case à cocher",
  "Radio": "Bouton radio",
  "Textarea": "Zone de texte",
  "Rating": "Évaluation",
  "File Input": "Entrée de fichier",
  "Otp Input": "Entrée OTP",
  "Form Layout": "Disposition du formulaire",
  "Form Validation": "Validation de formulaire",
  "Charts": "Graphiques",
  "Apex Chart": "Graphique Apex",
  "Chartjs": "Chartjs",
  "Account Settings": "Paramètres du compte",
  "User Profile": "Profil de l'utilisateur",
  "FAQ": "FAQ",
  "Dialog Examples": "Exemples de dialogue",
  "Pricing": "Tarification",
  "List": "Liste",
  "Edit": "Éditer",
  "Nav Levels": "Niveaux de navigation",
  "Level 2.1": "Niveau 2.1",
  "Level 2.2": "Niveau 2.2",
  "Level 3.1": "Niveau 3.1",
  "Level 3.2": "Niveau 3.2",
  "Raise Support": "Obtenir du support",
  "Documentation": "Documentation",
  "Dashboards": "Tableaux de bord",
  "Analytics": "Analytique",
  "Apps & Pages": "Applications & Pages",
  "Email": "Email",
  "Chat": "Discussion",
  "Invoice": "Facture",
  "Preview": "Aperçu",
  "Add": "Ajouter",
  "User": "Utilisateur",
  "View": "Vue",
  "Login v1": "Connexion v1",
  "Login v2": "Connexion v2",
  "Register v1": "Inscription v1",
  "Register v2": "Inscription v2",
  "Register": "S'inscrire",
  "Forget Password v1": "Mot de passe oublié v1",
  "Forget Password v2": "Mot de passe oublié v2",
  "Forgot Password v1": "Mot de passe oublié v1",
  "Forgot Password v2": "Mot de passe oublié v2",
  "Forgot Password": "Mot de passe oublié",
  "Reset Password v1": "Réinitialiser mot de passe v1",
  "Reset Password v2": "Réinitialiser mot de passe v2",
  "Reset Password": "Réinitialiser le mot de passe",
  "Miscellaneous": "Divers",
  "Coming Soon": "Bientôt disponible",
  "Not Authorized": "Non autorisé",
  "Under Maintenance": "En maintenance",
  "Error": "Erreur",
  "Statistics": "Statistiques",
  "Actions": "Actions",
  "Access Control": "Contrôle d'accès",
  "User Interface": "Interface utilisateur",
  "CRM": "GRC",
  "eCommerce": "Commerce électronique",
  "Icons": "Icônes",
  "Chip": "Puce",
  "Dialog": "Dialogue",
  "Expansion Panel": "Panneau d'expansion",
  "Combobox": "Boîte combinée",
  "Textfield": "Champ de texte",
  "Range Slider": "Curseur de plage",
  "Menu": "Menu",
  "Snackbar": "Snackbar",
  "Tabs": "Onglets",
  "Form Elements": "Éléments de formulaire",
  "Form Layouts": "Dispositions de formulaire",
  "Authentication": "Authentification",
  "Page Not Found - 404": "Page non trouvée - 404",
  "Not Authorized - 401": "Non autorisé - 401",
  "Server Error - 500": "Erreur serveur - 500",
  "2": "2",
  "Forms": "Formulaires",
  "Timeline": "Chronologie",
  "Disabled Menu": "Menu désactivé",
  "Help Center": "Centre d'aide",
  "Verify Email": "Vérifier l'email",
  "Verify Email v1": "Vérifier l'email v1",
  "Verify Email v2": "Vérifier l'email v2",
  "Two Steps": "Deux étapes",
  "Two Steps v1": "Deux étapes v1",
  "Two Steps v2": "Deux étapes v2",
  "Custom Input": "Entrée personnalisée",
  "Extensions": "Extensions",
  "Tour": "Visite",
  "Register Multi-Steps": "Inscription Multi-Étapes",
  "Wizard Examples": "Exemples d'assistant",
  "Checkout": "Paiement",
  "Create Deal": "Créer une offre",
  "Property Listing": "Liste de propriétés",
  "Roles & Permissions": "Rôles & Permissions",
  "Roles": "Rôles",
  "Simple Table": "Tableau simple",
  "Tables": "Tableaux",
  "Data Table": "Tableau de données",
  "Permissions": "Permissions",
  "Apps": "Applications",
  "Misc": "Divers",
  "Wizard Pages": "Pages de l'assistant",
  "Form Wizard": "Assistant de formulaire",
  "Numbered": "Numéroté",
  "3": "3",
  "ecommerce": "commerce électronique",
  "Ecommerce": "Commerce électronique",
  "Editors": "Éditeurs",
  "Front Pages": "Pages publiques",
  "Landing": "Page de destination",
  "checkout": "paiement",
  "Payment": "Paiement",
  "Swiper": "Swiper",
  "Product": "Produit",
  "Category": "Catégorie",
  "Order": "Commande",
  "Details": "Détails",
  "Customer": "Client",
  "Manage Review": "Gérer les avis",
  "Referrals": "Parrainages",
  "Settings": "Paramètres",
  "Overview": "Aperçu",
  "My Course": "Mon cours",
  "Course Details": "Détails du cours",
  "Academy": "Académie",
  "Logistics": "Logistique",
  "Dashboard": "Tableau de bord",
  "Fleet": "Flotte",
  "5": "5",
  "10": "10",
  "20": "20",
  "25": "25",
  "50": "50",
  "100": "100",
  "maintenance": "Maintenance",
  "maintenance-page": {
    "title": "Paramètres de maintenance",
    "notification_section": "Notification globale",
    "notification_placeholder": "Saisissez le message de notification pour tous les utilisateurs",
    "notification_hint": "Ce message sera affiché à tous les utilisateurs authentifiés sous forme d'avertissement",
    "games_section": "Blocage des sessions",
    "games_blocked_label": "Bloquer les nouvelles sessions",
    "games_blocked_hint": "Lorsque activé, les utilisateurs ne peuvent pas créer ou démarrer de nouvelles sessions. Les sessions en cours peuvent toujours être rejointes.",
    "save": "Enregistrer",
    "clear": "Effacer",
    "clear_confirm": "Êtes-vous sûr de vouloir effacer la notification ?",
    "last_updated": "Dernière mise à jour",
    "updated_by": "par",
    "games_blocked_message": "Nous nous excusons pour la gêne occasionnée. La plateforme est actuellement en maintenance. Les sessions sont temporairement indisponibles."
  },
  "$vuetify": {
    "badge": "Badge",
    "noDataText": "Aucune donnée disponible",
    "close": "Fermer",
    "open": "ouvrir",
    "carousel": {
      "ariaLabel": {
        "delimiter": "délimiteur"
      }
    },
    "dataFooter": {
      "itemsPerPageText": "Articles par page :",
      "itemsPerPageAll": "Tout",
      "pageText": "{0}-{1} de {2}",
      "firstPage": "Première Page",
      "prevPage": "Page Précédente",
      "nextPage": "Page Suivante",
      "lastPage": "Dernière Page"
    },
    "pagination": {
      "ariaLabel": {
        "root": "racine",
        "previous": "précédent",
        "next": "suivant",
        "first": "premier",
        "last": "dernier",
        "currentPage": "pageCourante",
        "page": "page"
      }
    },
    "input": {
      "clear": "effacer",
      "appendAction": "appendAction",
      "prependAction": "prependAction",
      "counterSize": "counterSize",
      "otp": "otp"
    },
    "fileInput": {
      "counterSize": "counterSize"
    },
    "rating": {
      "ariaLabel": {
        "item": "élément"
      }
    }
  },
  "skill_reports": {
    "skill_development_report": "Rapport de développement des compétences",
    "generate": "Générer",
    "generate_description": "Générer un rapport complet de développement des compétences pour une période sélectionnée",
    "manager_description": "Générer des rapports de développement des compétences pour les employés de votre organisation",
    "date": "Date",
    "competence": "Compétence",
    "period": "Période",
    "status_label": "Statut",
    "actions": "Actions",
    "employee": "Employé",
    "view": "Voir le rapport",
    "download_pdf": "Télécharger le PDF",
    "no_reports": "Aucun rapport généré pour le moment",
    "data_not_available": "Les données du rapport ne sont pas encore disponibles",
    "generation_failed": "La génération du rapport a échoué",
    "retry": "Réessayer",
    "rate_limit_exceeded": "Limite de génération de rapports atteinte. Veuillez réessayer plus tard.",
    "too_many_pending": "Vous avez trop de rapports en cours. Veuillez attendre qu'ils soient terminés.",
    "no_games_for_report": "Aucune session terminée trouvée pour la période et la compétence sélectionnées. Le rapport ne peut pas être généré.",
    "report_already_exists": "Un rapport avec ces paramètres existe déjà. Consultez la liste ci-dessous.",
    "period_too_long": "La période du rapport ne doit pas dépasser un an.",
    "invalid_parameters": "Vérifiez la compétence et la période",
    "filter_by_employee": "Filtrer par employé...",
    "batch": {
      "mode_single": "Rapport unique",
      "mode_batch": "Lot",
      "load_employees": "Afficher les collaborateurs",
      "sessions": "Sessions",
      "no_candidates": "Aucun collaborateur avec des sessions terminées pour la compétence et la période sélectionnées",
      "generate_selected": "Générer ({count})",
      "selected_limit": "Vous pouvez sélectionner au maximum {max} collaborateurs à la fois",
      "progress": "{ready} sur {total} prêts",
      "failed_count": "Échecs : {count}",
      "status_unknown": "Statut inconnu",
      "status_unknown_hint": "Le rapport est introuvable dans la liste — consultez le tableau des rapports ci-dessous",
      "reused": "Rapports réutilisés : {count} — générés au cours des {hours} dernières heures et non recréés",
      "reused_badge": "Réutilisé",
      "reused_on": "Généré le {date}",
      "download_all": "Tout télécharger",
      "toggle_details": "Afficher le contenu du lot",
      "dismiss_confirm": "Ce lot est encore en cours de génération. Le retirer de l'écran ? La progression et le bouton « Tout télécharger » seront perdus ; les rapports restent dans la liste ci-dessous.",
      "archive_unavailable": "Impossible de constituer l'archive : certains rapports ne sont pas encore prêts ou ne sont plus disponibles",
      "archive_failed": "Impossible de télécharger l'archive",
      "archive_building": "Création de l'archive…",
      "archive_build_failed": "Impossible de constituer l'archive. Réessayez.",
      "candidates_failed": "Impossible de charger la liste des collaborateurs",
      "stale_selection": "Certains collaborateurs sélectionnés ne sont plus disponibles. La liste a été actualisée — sélectionnez à nouveau."
    },
    "quota": {
      "remaining_hour": "Limite de rapports : {limit} par heure. Vous pouvez encore en demander {remaining} dès maintenant. Sélectionnez moins de collaborateurs ou réessayez à {time}.",
      "remaining_day": "Limite de rapports : {limit} par jour. Vous pouvez encore en demander {remaining} dès maintenant. Sélectionnez moins de collaborateurs ou réessayez à {time}.",
      "exhausted_hour": "Limite de rapports atteinte ({limit} par heure). Elle sera réinitialisée à {time}.",
      "exhausted_day": "Limite de rapports atteinte ({limit} par jour). Elle sera réinitialisée à {time}.",
      "too_large_hour": "Limite de rapports : {limit} par heure. Sélectionnez moins de collaborateurs.",
      "too_large_day": "Limite de rapports : {limit} par jour. Sélectionnez moins de collaborateurs."
    },
    "status": {
      "pending": "En attente",
      "collecting_data": "Collecte des données...",
      "analyzing": "Analyse IA...",
      "generating_pdf": "Génération du PDF...",
      "ready": "Prêt",
      "failed": "Échec"
    },
    "report": {
      "kicker": "Rapport de développement d'une compétence",
      "position": "Poste",
      "department": "Département",
      "period": "Période",
      "games_count": "Sessions réalisées",
      "not_specified_f": "Non spécifiée",
      "not_specified_n": "Non spécifié",
      "fig": {
        "your_average": "Votre score moyen",
        "company_average": "Moyenne de l'entreprise",
        "participants": "Participants sur la période",
        "skills_count": "Aptitudes évaluées"
      },
      "sec": {
        "profile": "Profil de la compétence",
        "trend": "Évolution au fil des sessions",
        "strengths": "Sur quoi vous appuyer",
        "priorities": "Trois priorités de développement",
        "skills": "Analyse par aptitude",
        "plan": "Plan sur trois mois"
      },
      "legend": {
        "you": "Votre score",
        "company": "Moyenne de l'entreprise"
      },
      "dotplot_caption": "Écart à la moyenne — de la plus forte avance au plus fort retard",
      "trend_disclaimer": "Les scores des sessions ne sont pas directement comparables : la difficulté des cas varie d'une session à l'autre. Une baisse ne signifie pas à elle seule un recul de l'aptitude — ce graphique est une observation, pas un verdict.",
      "no_comparison": "La comparaison avec la moyenne de l'entreprise n'est pas disponible : sur la période, moins de trois personnes ont réalisé des sessions sur cette compétence. Le rapport repose sur les scores absolus.",
      "skill": {
        "works": "Ce qui fonctionne",
        "blocks": "Ce qui freine",
        "actions": "Que faire",
        "out_of_ten": "sur 10",
        "company_short": "entreprise"
      },
      "level": {
        "outstanding": "Résultat remarquable",
        "strength": "Point fort",
        "meets_standard": "Au niveau de l'entreprise",
        "needs_attention": "Point de vigilance",
        "needs_development": "Axe de développement"
      },
      "plan": {
        "month": "Mois",
        "goals": "Objectifs",
        "actions": "Actions"
      },
      "colophon": {
        "built_on": "Le rapport s'appuie sur les sessions de la période {from} — {to}. Nombre total de sessions : {count}.",
        "comparison": "La comparaison porte sur la moyenne de l'entreprise pour la même période. Participants : {count}."
      }
    }
  },
    "api-tokens": "Jetons API",
    "api-tokens-page": {
        "select_user": "Utilisateur",
        "select_user_hint": "Sélectionnez un utilisateur pour afficher et gérer ses jetons API.",
        "no_users_found": "Aucun utilisateur trouvé",
        "no_tokens": "Cet utilisateur n'a pas de jetons API.",
        "token_name": "Nom",
        "abilities": "Autorisations",
        "ability": "Autorisation",
        "created_at": "Créé le",
        "last_used_at": "Dernière utilisation",
        "expires_at": "Expire le",
        "actions": " ",
        "issue_token": "Émettre un jeton",
        "issue": "Émettre",
        "issue_failed": "Échec de l'émission du jeton",
        "token": "Jeton",
        "plaintext_warning": "Copiez ce jeton maintenant — il ne sera plus affiché.",
        "revoke": "Révoquer",
        "revoke_confirm": "Êtes-vous sûr de vouloir révoquer ce jeton ? Les intégrations qui l'utilisent cesseront de fonctionner."
    },
  "subscription": {
    "current_plan": "Abonnement actuel",
    "expires_at": "Expire le : {date}",
    "no_active_plan": "Aucun abonnement actif",
    "quota_warning": "Quota restant faible",
    "regular_games": "Sessions régulières",
    "ai_games": "Sessions IA",
    "any_games": "Toutes les sessions",
    "used_of": "{used} sur {limit}",
    "remaining": "{count} restant(s)",
    "quota_exceeded": "Quota de fonctionnalité dépassé",
    "tickets_only": "Forfaits crédits",
    "session_package": "Forfait de sessions",
    "games_available": "Sessions",
    "users": "Utilisateurs",
    "active_users": "Utilisateurs actifs",
    "active_tickets": "Forfaits crédits",
    "ticket_charges": "{charges} crédits",
    "ticket_no_expiry": "Sans expiration",
    "unlimited": "Illimité",
    "no_game_limits": "Aucune restriction sur le nombre de sessions"
  },
  "knowledge-base-page": {
    "provider-unsupported": "La base de connaissances n'est pas disponible avec le fournisseur d'IA actuel de votre organisation."
  },
  "candidate-page": {
    "document_title": "Entretien",
    "greeting": "Bonjour, {name} !",
    "intro_lead": "{organization} vous invite à passer un entretien avec un interlocuteur virtuel pour le poste « {vacancy} ».",
    "duration": "L'entretien dure environ {minutes} min.",
    "requirements_title": "Ce dont vous aurez besoin",
    "requirement_mic": "Un microphone fonctionnel, idéalement un casque",
    "requirement_camera_required": "Une caméra activée : elle est obligatoire pour cet entretien",
    "requirement_camera_optional": "La caméra est facultative, mais la conversation est plus naturelle avec elle",
    "requirement_browser": "Un ordinateur avec une version récente de Chrome, Edge ou Safari",
    "requirement_network": "Une connexion stable et un endroit calme où personne ne vous interrompra",
    "continue": "Continuer",
    "consent": {
      "accept": "J'ai pris connaissance du texte et je consens au traitement de mes données personnelles",
      "back": "Retour",
      "start": "Démarrer l'entretien"
    },
    "terminal": {
      "finished": {
        "title": "Merci !",
        "text": "L'entretien est terminé, le résultat a été transmis au recruteur — il vous contactera. Vous pouvez fermer cette page."
      },
      "already_completed": {
        "title": "Entretien déjà terminé",
        "text": "L'entretien associé à ce lien est déjà terminé. Si vous devez le repasser, contactez le recruteur."
      },
      "not_found": {
        "title": "Lien introuvable",
        "text": "L'adresse contient peut-être une erreur, ou le lien n'est plus valide. Vérifiez l'email du recruteur ou contactez-le."
      },
      "session_conflict": {
        "title": "Vous êtes connecté à un autre compte",
        "text": "Déconnectez-vous du compte actuel ou ouvrez le lien dans une fenêtre de navigation privée."
      },
      "link_revoked": {
        "title": "L'accès à ce lien est fermé",
        "text": "Le recruteur a révoqué ce lien. Contactez-le pour en obtenir un nouveau."
      },
      "link_expired": {
        "title": "Le lien a expiré",
        "text": "Contactez le recruteur pour qu'il vous délivre un nouveau lien."
      },
      "attempts_exhausted": {
        "title": "Plus aucune tentative disponible",
        "text": "Toutes les tentatives disponibles pour ce lien ont été utilisées. Contactez le recruteur."
      },
      "unavailable": {
        "title": "Impossible de démarrer pour le moment",
        "text": "Réessayez plus tard ou contactez le recruteur."
      },
      "rate_limited": {
        "title": "Trop de tentatives",
        "text": "Patientez une minute puis actualisez la page."
      },
      "aborted": {
        "title": "L'entretien n'a pas démarré",
        "text": "Actualisez la page et réessayez. Si cela ne suffit pas, contactez le recruteur."
      },
      "generic": {
        "title": "Une erreur s'est produite",
        "text": "Actualisez la page et réessayez. Si cela ne suffit pas, contactez le recruteur."
      }
    }
  },
  "recruiting-page": {
    "title": "Recrutement",
    "create": "Créer un poste",
    "edit": "Modifier le poste",
    "empty": "Aucun poste pour l'instant",
    "load_error": "Impossible de charger la liste des postes",
    "retry": "Réessayer",
    "back": "Retour aux postes",
    "open": "Candidats",
    "archive": "Archiver",
    "no_expiry": "Sans expiration",
    "confirm_archive": "Archiver ce poste ? Vous ne pourrez plus y délivrer de liens.",
    "headers": {
      "title": "Poste",
      "scenario": "Scénario",
      "status": "Statut",
      "expires_at": "Valide jusqu'au",
      "actions": "Actions"
    },
    "status": {
      "draft": "Brouillon",
      "active": "Actif",
      "archived": "Archivé"
    },
    "dialog": {
      "title_label": "Titre du poste",
      "scenario_label": "Scénario de l'entretien",
      "scenario_placeholder": "Choisissez un scénario pour l'entretien avec l'IA",
      "scenario_hint": "Seuls les scénarios compatibles avec une session contre IA sont proposés",
      "status_label": "Statut",
      "expires_label": "Valide jusqu'au",
      "expires_hint": "Vide = poste sans expiration",
      "save": "Enregistrer",
      "cancel": "Annuler"
    },
    "messages": {
      "created": "Poste créé",
      "updated": "Poste mis à jour",
      "archived": "Poste archivé",
      "revoked": "Lien révoqué",
      "attempt_granted": "Tentative supplémentaire accordée",
      "copied": "Lien copié",
      "error": "Une erreur s'est produite"
    },
    "candidates": {
      "title": "Candidats",
      "empty": "Aucun lien n'a encore été délivré pour ce poste",
      "load_error": "Impossible de charger la liste des candidats",
      "issue": "Délivrer un lien",
      "import": "Importer depuis un fichier",
      "expired": "Expiré",
      "no_games": "Entretien non commencé",
      "attempts": "{used} sur {allowed}",
      "revoke": "Révoquer le lien",
      "extra_attempt": "Accorder une tentative supplémentaire",
      "open_result": "Voir le résultat de l'entretien",
      "confirm_revoke": "Révoquer le lien de ce candidat ? L'accès sera coupé immédiatement, y compris pour un entretien en cours.",
      "confirm_extra_attempt": "Accorder une tentative supplémentaire à ce candidat ?",
      "headers": {
        "candidate": "Candidat",
        "link_status": "Lien",
        "invite": "Invitation",
        "game_status": "Entretien",
        "attempts": "Tentatives",
        "expires_at": "Lien valide jusqu'au",
        "actions": "Actions"
      },
      "link_status": {
        "created": "Délivré",
        "opened": "Ouvert",
        "in_progress": "Entretien en cours",
        "completed": "Entretien terminé",
        "revoked": "Révoqué"
      },
      "invite_status": {
        "not_sent": "Non envoyée",
        "queued": "En file d'attente",
        "sent": "Envoyée",
        "failed": "Échec de l'envoi"
      },
      "invite_sent_at": "Email accepté par le service de messagerie le {date}",
      "invite_failure": {
        "rejected": "Le service de messagerie a refusé l'email — transmettez le lien au candidat vous-même",
        "transport": "Échec de l'envoi — transmettez le lien au candidat vous-même",
        "revoked": "Le lien a été révoqué",
        "sending_disabled": "L'envoi d'emails est désactivé",
        "blocked": "L'adresse figure dans la liste de blocage — transmettez le lien au candidat vous-même"
      }
    },
    "issue_dialog": {
      "title": "Délivrer un lien personnel",
      "name": "Prénom",
      "last_name": "Nom",
      "email": "Email",
      "phone": "Téléphone",
      "attempts": "Nombre de tentatives",
      "expires_at": "Lien valide jusqu'au",
      "expires_hint": "Vide = reprend la date d'expiration du poste",
      "submit": "Délivrer le lien",
      "close": "Fermer",
      "result_title": "Lien délivré",
      "warning": "Copiez le lien maintenant — il ne s'affiche qu'une seule fois. Seul son hachage est conservé en base, il est donc impossible de le récupérer : un lien perdu doit être révoqué puis délivré à nouveau.",
      "copy": "Copier",
      "copied": "Copié",
      "send_invite": "Envoyer une invitation à {email}",
      "send_invite_no_email": "Envoyer une invitation par email",
      "send_invite_blocked": "Cette adresse figure dans la liste de blocage — l'email ne sera pas envoyé",
      "invite_queued": "Invitation mise en file d'attente pour {email}",
      "invite_blocked": "Invitation non envoyée : {email} figure dans la liste de blocage. Transmettez le lien au candidat vous-même"
    },
    "import_dialog": {
      "title": "Importation de candidats",
      "subtitle": "Chaque ligne du fichier correspond à un candidat et à un lien personnel.",
      "file": "Fichier de la liste des candidats",
      "columns": "Colonnes : Prénom, Nom, Email, Téléphone",
      "limits": "xlsx ou CSV (« ; »), 200 lignes et 10 Mo max",
      "size_error": "Le fichier dépasse 10 Mo",
      "download_example": "Télécharger le modèle",
      "note_title": "Les liens ne sont visibles que dans le fichier téléchargé",
      "note_text": "Le fichier se télécharge dès la fin de l'import. Seuls les hachages des liens sont conservés : il est impossible de les exporter une seconde fois — conservez ce fichier.",
      "submit": "Importer",
      "cancel": "Annuler",
      "result_title": "Liens délivrés",
      "result": "Liens délivrés : {count}. Le fichier a été téléchargé.",
      "invites_blocked": "Invitations non envoyées : {count}. Ces adresses figurent dans la liste de blocage — transmettez les liens à ces candidats vous-même.",
      "saved_title": "Conservez le fichier téléchargé",
      "saved_text": "C'est l'unique copie de ces liens : la base ne conserve que leur hachage. Un lien perdu ne peut être que révoqué puis délivré à nouveau.",
      "download_again": "Télécharger le fichier à nouveau",
      "errors_title": "Lignes rejetées",
      "error_row": "Ligne {row} : {error}",
      "errors_truncated": "… et {count} lignes rejetées supplémentaires. Les 50 premières sont affichées ci-dessus.",
      "send_invites": "Envoyer des invitations par email aux candidats",
      "send_invites_hint": "Les candidats sans adresse email n'en recevront pas"
    }
  },
  "ai-reports": "Rapports IA",
  "ai-reports-page": {
    "title": "Rapports IA",
    "subtitle": "Décrivez le rapport avec vos propres mots : nous construisons la spécification, affichons un aperçu et l'exportons vers Excel.",
    "status": {
      "draft": "Brouillon",
      "pending": "En cours de génération",
      "ready": "Prêt",
      "failed": "Échec"
    },
    "list": {
      "title": "Mes rapports",
      "new": "Nouveau rapport",
      "empty": "Aucun rapport pour l'instant. Cliquez sur « Nouveau rapport » et décrivez ce qu'il faut afficher.",
      "untitled": "Sans titre",
      "delete": "Supprimer le rapport",
      "delete_confirm": "Supprimer ce rapport ainsi que le fichier généré ?",
      "deleted": "Rapport supprimé"
    },
    "dialog": {
      "title": "Dialogue",
      "open_dictionary": "Référentiel de données",
      "placeholder": "Par exemple : combien de parties chaque service a-t-il menées le dernier trimestre",
      "send": "Envoyer",
      "empty_title": "Que doit montrer le rapport ?",
      "empty_text": "Décrivez-le avec des mots simples : quelles données, pour quelle période et selon quelle répartition. S'il manque quelque chose, je vous le demanderai.",
      "examples_title": "Par exemple :",
      "examples": {
        "e1": "Combien de parties chaque service a-t-il menées le dernier trimestre",
        "e2": "Score moyen de compétences dans le service commercial pour 2026",
        "e3": "Employés n'ayant pas joué depuis plus d'un mois",
        "e4": "Candidats par poste et statut de leur lien sur les 30 derniers jours"
      },
      "thinking": "Génération du rapport…",
      "waiting_hint": "La réponse apparaîtra ici toute seule : inutile d'actualiser la page.",
      "retry": "Réessayer",
      "dismiss": "Masquer",
      "spec_ready": "Le rapport est prêt : consultez l'aperçu ci-dessous et générez le fichier.",
      "stuck_title": "On dirait que nous tournons en rond",
      "stuck_text": "Consultez le référentiel de données et reformulez la demande avec ses termes : c'est plus rapide que de répondre à une question de clarification supplémentaire.",
      "rejected_title": "Ce rapport ne peut pas encore être généré",
      "reason": {
        "no_such_measure": "Cet indicateur n'existe pas dans nos données. Consultez la liste des indicateurs dans le référentiel.",
        "no_such_field": "Ce champ n'existe pas dans nos données. Consultez la liste des champs dans le référentiel.",
        "cross_dataset": "La demande nécessite des données provenant de deux jeux de données à la fois. Divisez-la en deux rapports.",
        "window_function": "Les parts du total, les rangs de classement et la comparaison avec la période précédente ne sont pas encore pris en charge.",
        "other": "La demande dépasse les données disponibles. Consultez le référentiel et essayez une autre formulation."
      },
      "usage": {
        "employees": "aucun employé | {n} employé | {n} employés",
        "games": "aucune partie | {n} partie | {n} parties",
        "scenarios": "aucun scénario | {n} scénario | {n} scénarios",
        "evaluations": "aucune évaluation | {n} évaluation | {n} évaluations",
        "candidates": "aucun candidat | {n} candidat | {n} candidats"
      },
      "option_created_at": "ajout : {date}"
    },
    "preview": {
      "title": "Aperçu",
      "no_report": "Choisissez un rapport à gauche ou commencez-en un nouveau.",
      "no_spec": "Décrivez le rapport dans le dialogue : l'aperçu apparaîtra dès que la demande sera comprise.",
      "spec_title": "Ce que contiendra le rapport",
      "rows_hint": "Les {count} premières lignes sont affichées",
      "total": "Total des lignes : {count}",
      "zero_rows": "Cette demande ne renvoie aucune ligne. Élargissez la période ou retirez des filtres : générer un fichier vide n'a pas d'intérêt.",
      "zero_rows_hint": "Vérifiez les valeurs des filtres : il se peut qu'il n'y ait pas de données pour elles",
      "duplicate_rows": "Certaines lignes de l’aperçu sont identiques : les colonnes choisies ne distinguent pas les enregistrements de ce jeu de données. Vérifiez ce que représente réellement une ligne ici — il manque peut-être une colonne qui les différencie.",
      "too_many_rows": "Le rapport contient {count} lignes, le maximum est {max}. Restreignez la période ou ajoutez des filtres : au-delà du plafond, le fichier n'est pas généré du tout plutôt que tronqué.",
      "generate": "Générer le fichier",
      "regenerate": "Régénérer",
      "queued": "Le fichier est en cours de génération : la carte se met à jour automatiquement une fois prêt.",
      "failed": "Le rapport n'a pas pu être généré",
      "download": "Télécharger le .xlsx",
      "downloads": "Téléchargements : {count}",
      "ttl_warning": "Le fichier est conservé {days} jours puis supprimé — téléchargez-le sans attendre.",
      "expires_at": "Disponible jusqu'au {date}",
      "expired": "Le fichier a été supprimé à l'expiration de sa durée de conservation — générez le rapport à nouveau."
    },
    "spec": {
      "dataset": "Données",
      "columns": "Colonnes",
      "measures": "Mesures",
      "group_by": "Répartition",
      "period": "Période",
      "period_value": "{field} : du {from} au {to}",
      "period_all": "Toute la période disponible",
      "filters": "Filtres",
      "having": "Conditions sur les mesures",
      "sort": "Tri",
      "limit": "Limite de lignes",
      "limit_value": "{count} premières lignes",
      "granularity": {
        "year": "par année",
        "quarter": "par trimestre",
        "month": "par mois",
        "week": "par semaine",
        "day": "par jour",
        "dow": "par jour de la semaine"
      },
      "dir": {
        "asc": "croissant",
        "desc": "décroissant"
      },
      "filter": {
        "equals": "{field} — {value}",
        "not_equals": "{field} — différent de {value}",
        "in": "{field} — l'une des valeurs : {value}",
        "not_in": "{field} — sauf : {value}",
        "gt": "{field} supérieur à {value}",
        "gte": "{field} au moins {value}",
        "lt": "{field} inférieur à {value}",
        "lte": "{field} au plus {value}",
        "contains": "{field} contient « {value} »",
        "between": "{field} — du {from} au {to}",
        "is_null": "{field} non renseigné",
        "is_not_null": "{field} renseigné"
      }
    },
    "value": {
      "yes": "Oui",
      "no": "Non"
    },
    "dictionary": {
      "title": "Référentiel de données",
      "subtitle": "Tout ce qui peut être intégré à un rapport. La liste est en direct : c'est la même à partir de laquelle la spécification est construite.",
      "fields": "Champs",
      "measures": "Mesures",
      "values": "Valeurs",
      "show_values": "Afficher les valeurs de votre organisation",
      "hide_values": "Masquer les valeurs",
      "values_error": "Les valeurs n'ont pas pu être chargées : réessayez.",
      "values_empty": "Votre organisation n'a pas encore de valeurs pour ce champ.",
      "limits": {
        "title": "Ce qu'un rapport ne peut pas faire",
        "pivot": "Un tableau croisé avec une colonne par participant ou par question ne pourra pas être généré. Demandez plutôt la forme longue : une ligne par paire participant-question.",
        "window": "Le rapport ne calcule pas l'évolution mois par mois, la part du total, le rang dans un classement ni « le top trois de chaque département ». Prenez la répartition par mois et terminez le calcul dans Excel.",
        "missing": "Ce que le système ne stocke pas n'apparaîtra jamais dans un rapport : les salaires, le NPS et toute autre donnée conservée ailleurs, sous quelque nom que ce soit."
      },
      "empty": "Le référentiel est vide — contactez votre administrateur.",
      "close": "Fermer"
    },
    "errors": {
      "generic": "Une erreur s'est produite. Veuillez réessayer.",
      "detail": "Non compris : {value}",
      "rate_limit": "Trop de requêtes. Attendez une minute et réessayez.",
      "download": "Le fichier n'a pas pu être téléchargé.",
      "turn_failed": "La réponse n'a pas pu être obtenue. Envoyez à nouveau votre demande.",
      "turn_stuck_in_queue": "La demande n'a jamais été traitée : elle a attendu trop longtemps dans la file. Envoyez-la à nouveau.",
      "unknown_resolution": "Cette option n'est plus valable : le rapport a changé entre-temps. Rouvrez-le et précisez votre demande."
    }
  },
    "externalLaunch": {
        "document_title": "Session d'entraînement",
        "intro": {
            "title": "Conversation d'entraînement",
            "lead": "Vous allez vous entretenir avec un interlocuteur virtuel. La conversation est enregistrée et évaluée, et le résultat sera transmis à votre système de formation.",
            "requirements_title": "Ce dont vous aurez besoin",
            "requirement_mic": "Un microphone fonctionnel, idéalement un casque",
            "requirement_camera": "Une caméra est facultative, mais la conversation est plus naturelle avec elle",
            "requirement_browser": "Un ordinateur avec une version récente de Chrome, Edge ou Safari",
            "requirement_network": "Une connexion stable et un endroit calme où personne ne vous interrompra",
            "start": "Démarrer"
        },
        "relaunch_hint": "Retournez dans votre système de formation et rouvrez le contenu.",
        "saving": "Enregistrement du résultat…",
        "review": {
            "document_title": "Bilan de la session",
            "attempt": "Tentative {number}",
            "result": {
                "passed": "Réussi",
                "failed": "Non réussi",
                "pending": "Pas encore évalué"
            },
            "score_of_100": "{score} sur 100",
            "threshold": "Seuil de réussite : {threshold}",
            "skills_title": "Compétences et recommandations",
            "skills_empty": "Il n'y a pas encore de retour détaillé par compétence pour cette tentative.",
            "comments_title": "Commentaires sur l'enregistrement",
            "comments_empty": "Il n'y a pas de commentaire sur cet enregistrement.",
            "loading": "Chargement du bilan",
            "error": {
                "not_found": {
                    "title": "Le lien ne fonctionne pas",
                    "text": "Le bilan n'est plus disponible : le lien a expiré ou la tentative a été révoquée."
                },
                "expired": {
                    "title": "La page a expiré",
                    "text": "Rouvrez le bilan depuis le lien de votre système de formation."
                },
                "generic": {
                    "title": "Impossible d'afficher le bilan",
                    "text": "Une erreur s'est produite de notre côté. Essayez de rouvrir le lien."
                }
            }
        },
        "terminal": {
            "finished": {
                "title": "Merci !",
                "text": "La conversation est terminée. Le résultat apparaîtra dans votre système de formation une fois l'évaluation prête. Vous pouvez fermer cette page."
            },
            "aborted": {
                "title": "La conversation n'a pas démarré",
                "text": "Une erreur s'est produite avant le début de la conversation."
            },
            "token_expired": {
                "title": "La session a expiré",
                "text": "L'accès à cette conversation n'est plus valide."
            },
            "not_found": {
                "title": "Le lien ne fonctionne pas",
                "text": "L'adresse contient peut-être une erreur, ou le lien n'est plus valide."
            },
            "rate_limited": {
                "title": "Trop de tentatives",
                "text": "Patientez une minute avant de réessayer."
            },
            "generic": {
                "title": "Impossible de démarrer pour le moment",
                "text": "Une erreur s'est produite de notre côté."
            }
        },
        "refusal": {
            "publication_disabled": {
                "title": "Le contenu est fermé",
                "text": "Ce contenu n'est plus disponible pour l'entraînement."
            },
            "publication_draft": {
                "title": "Le contenu n'est pas encore publié",
                "text": "L'entraînement sur ce contenu n'a pas encore été ouvert."
            },
            "publication_expired": {
                "title": "Le contenu a expiré",
                "text": "La période pendant laquelle ce contenu pouvait être pratiqué est terminée."
            },
            "feature_disabled": {
                "title": "Le contenu est fermé",
                "text": "L'entraînement depuis le système de formation est désactivé pour votre organisation."
            },
            "connection_disabled": {
                "title": "Le contenu est fermé",
                "text": "La connexion à votre système de formation est désactivée. Contactez la personne qui vous a attribué le cours."
            },
            "launch_limit_reached": {
                "title": "La limite est atteinte",
                "text": "Ce contenu a déjà été utilisé pour le nombre maximal de conversations."
            },
            "daily_budget_exhausted": {
                "title": "C'est suffisant pour aujourd'hui",
                "text": "Vous avez atteint le nombre de conversations autorisées par jour. Réessayez demain."
            },
            "attempts_exhausted": {
                "title": "Plus aucune tentative disponible",
                "text": "Vous avez utilisé toutes les tentatives autorisées pour ce contenu."
            },
            "quota_exhausted": {
                "title": "Impossible de démarrer pour le moment",
                "text": "Votre organisation n'a plus de conversations disponibles. Contactez la personne qui vous a attribué le cours."
            },
            "user_limit_reached": {
                "title": "Impossible de démarrer pour le moment",
                "text": "Votre organisation n'a plus de place disponible. Contactez la personne qui vous a attribué le cours."
            },
            "scenario_unavailable": {
                "title": "Le contenu est indisponible",
                "text": "La conversation associée à ce contenu n'existe plus."
            },
            "assignment_check_unavailable": {
                "title": "Impossible de démarrer pour le moment",
                "text": "Nous n'avons pas pu confirmer que ce contenu vous est attribué. Contactez la personne qui vous a attribué le cours."
            },
            "code_invalid": {
                "title": "Le lien n'est plus valide",
                "text": "Ce lien a déjà été utilisé ou son délai est dépassé."
            },
            "channel_verification_failed": {
                "title": "Le système de formation n'a pas répondu",
                "text": "Nous n'avons pas pu confirmer la requête auprès de votre système de formation."
            },
            "external_system_unavailable": {
                "title": "Le système de formation ne répond pas",
                "text": "Nous n'avons pas pu vérifier l'attribution de votre cours dans le système de formation. Réessayez dans quelques minutes."
            },
            "user_not_found": {
                "title": "Nous n'avons pas pu vous identifier",
                "text": "Aucun compte n'existe pour vous ici, et votre organisation ne les crée pas automatiquement. Contactez la personne qui vous a attribué le cours."
            },
            "user_unavailable": {
                "title": "Votre compte est désactivé",
                "text": "Contactez la personne qui vous a attribué le cours."
            },
            "user_deleted": {
                "title": "Votre compte est supprimé",
                "text": "Contactez la personne qui vous a attribué le cours."
            },
            "email_taken_linking_disabled": {
                "title": "Nous n'avons pas pu vous identifier",
                "text": "Votre adresse email appartient déjà à un autre compte ici. Contactez la personne qui vous a attribué le cours."
            },
            "service_role_not_allowed": {
                "title": "Ce compte ne peut pas s'entraîner",
                "text": "Les comptes administrateurs ne prennent pas part aux conversations d'entraînement. Utilisez votre propre compte apprenant."
            },
            "unverified_request": {
                "title": "Nous n'avons pas pu confirmer la requête",
                "text": "Votre système de formation n'a pas confirmé que cette conversation a été démarrée par vous."
            }
        },
        "manage": {
            "nav": {
                "group": "Lancement externe",
                "publications": "Publications",
                "connections": "Connexions LMS"
            },
            "messages": {
                "error": "Une erreur s'est produite. Réessayez.",
                "load_error": "Impossible de charger les données."
            },
            "connections": {
                "title": "Connexions LMS",
                "subtitle": "Comptes des systèmes de formation depuis lesquels cette organisation lance l'entraînement.",
                "create": "Ajouter une connexion",
                "edit": "Modifier",
                "set_credentials": "Définir les identifiants",
                "empty": "Aucune connexion pour le moment.",
                "secret_missing": "Non défini",
                "no_expiry": "N'expire pas",
                "headers": {
                    "account": "Compte",
                    "base_url": "Adresse",
                    "client_id": "ID client",
                    "secret": "Secret",
                    "status": "Statut",
                    "expires_at": "Expiration des identifiants",
                    "actions": " "
                },
                "status": {
                    "no_credentials": "Sans identifiants",
                    "active": "Active",
                    "expired": "Identifiants expirés",
                    "disabled": "Désactivée"
                },
                "lms": {
                    "ispring": "iSpring Learn"
                },
                "dialog": {
                    "create_title": "Nouvelle connexion",
                    "edit_title": "Connexion",
                    "immutable_hint": "Le système de formation et le compte ne peuvent pas être modifiés : ils définissent l'espace d'identité des apprenants. Un autre compte constitue une nouvelle connexion.",
                    "lms_label": "Système de formation",
                    "account_key_label": "Compte",
                    "account_key_hint": "L'identifiant du compte dans le système de formation.",
                    "base_url_label": "Adresse REST API iSpring",
                    "base_url_hint": "Par exemple, https://api-learn.ispringlearn.ru. Ce n'est pas l'adresse du portail de l'entreprise : c'est l'adresse à laquelle le secret est envoyé.",
                    "base_url_https": "L'adresse doit commencer par https://",
                    "enabled_label": "La connexion est active",
                    "enabled_hint": "Une connexion n'est jamais supprimée — elle est désactivée. Les publications et les lancements restent dans les listes, mais les nouveaux lancements sont refusés et les résultats ne partent plus vers le système de formation.",
                    "credentials_optional": "Les identifiants sont facultatifs. Sans eux, la connexion fonctionne en mode limité.",
                    "client_id_label": "ID client",
                    "secret_label": "Secret",
                    "secret_hint": "Stocké chiffré. Il ne peut plus jamais être relu — seuls les quatre derniers caractères sont affichés.",
                    "expires_at_label": "Expiration des identifiants",
                    "expires_at_hint": "Laissez vide si les identifiants n'expirent pas."
                },
                "credentials_dialog": {
                    "title": "Identifiants",
                    "lead": "Le nouveau secret remplace le précédent. La connexion garde son identifiant, et les liens des apprenants ainsi que leurs lancements restent en place.",
                    "secret_hint": "L'ancien secret n'est plus nécessaire et ne peut pas être relu."
                },
                "messages": {
                    "saved": "Connexion enregistrée",
                    "credentials_saved": "Identifiants enregistrés"
                }
            },
            "publications": {
                "title": "Publications",
                "subtitle": "Scénarios ouverts au lancement depuis un système de formation.",
                "create": "Nouvelle publication",
                "edit": "Modifier",
                "enable": "Activer",
                "disable": "Désactiver",
                "open_journal": "Journal",
                "download_package": "Télécharger le paquet",
                "empty": "Aucune publication pour le moment.",
                "no_connections": "Il n'y a pas encore de connexion à un système de formation. Un administrateur de la plateforme doit en créer une.",
                "no_expiry": "Sans expiration",
                "attempts_unlimited": "Illimité",
                "immutable_hint": "La connexion, le scénario et le canal de diffusion ne peuvent pas être modifiés : ils sont intégrés au paquet déjà déposé dans le système de formation. Tout le reste s'applique sans avoir à le reconstruire.",
                "headers": {
                    "scenario": "Scénario",
                    "connection": "Connexion",
                    "channel": "Canal",
                    "status": "Statut",
                    "settings": "Paramètres",
                    "expires_at": "Expire",
                    "actions": " "
                },
                "summary": {
                    "attempts": "Tentatives : {value}",
                    "threshold": "Seuil de réussite : {value}"
                },
                "status": {
                    "draft": "Brouillon",
                    "active": "Active",
                    "disabled": "Désactivée"
                },
                "channel": {
                    "scorm_1_2": "SCORM 1.2",
                    "scorm_2004": "SCORM 2004"
                },
                "result_mode": {
                    "status_only": "Statut seul",
                    "status_and_score": "Statut et score",
                    "status_score_and_review": "Statut, score et un lien vers le bilan"
                },
                "warnings": {
                    "limited_mode": "Mode limité : le score et le résultat n'apparaîtront pas dans le système de formation, et la vérification de l'attribution n'est pas effectuée.",
                    "connection_disabled": "La connexion est désactivée : les lancements qui passent par cette publication ne sont pas acceptés du tout tant qu’un administrateur ne la réactive pas.",
                    "assignment_check_off": "Avec cette option désactivée, une réattribution du cours n'est pas détectée.",
                    "no_course_binding": "La publication n'est pas liée à un cours — le score ne sera pas transmis au système de formation."
                },
                "dialog": {
                    "connection_label": "Connexion",
                    "scenario_label": "Scénario",
                    "channel_label": "Canal de diffusion",
                    "channel_hint": "Intégré au paquet et ne peut plus être modifié ensuite.",
                    "status_label": "Statut",
                    "status_hint": "Une publication n'est jamais supprimée — elle est désactivée. Les nouveaux lancements sont ensuite refusés et les résultats pas encore envoyés sont annulés.",
                    "settings_section": "Paramètres de tentative",
                    "attempts_label": "Tentatives par apprenant",
                    "attempts_unlimited": "Sans limite",
                    "daily_budget_label": "Lancements par jour et par apprenant",
                    "daily_budget_hint": "Protège le quota : chaque conversation démarrée est décomptée et jamais restituée.",
                    "result_mode_label": "Ce qui est transmis au système de formation",
                    "pass_threshold_label": "Seuil de réussite, 0-100",
                    "result_wait_label": "Attente de l'évaluation, en heures",
                    "result_wait_hint": "Passé ce délai, le lancement signale « aucun résultat ».",
                    "launch_limit_label": "Limite totale de lancements",
                    "launch_limit_hint": "Laissez vide pour aucune limite.",
                    "assignment_check_label": "Vérifier l'attribution dans le système de formation",
                    "binding_section": "Association dans le système de formation",
                    "external_course_label": "ID du cours",
                    "external_item_label": "ID de l'élément",
                    "expires_label": "Expiration de la publication",
                    "expires_hint": "Laissez vide si la publication n'expire pas."
                },
                "key_dialog": {
                    "title": "La publication est créée",
                    "warning": "La clé est affichée une seule fois et uniquement ici. Elle ne peut plus être relue nulle part — copiez-la maintenant et indiquez-la dans les paramètres du paquet. La perdre signifie créer une nouvelle publication.",
                    "key_label": "Clé de publication",
                    "copied": "Copié",
                    "package_hint": "La clé est déjà intégrée au paquet, il n'y a donc rien à coller nulle part. Téléchargez le paquet et téléversez-le dans le système de formation. Vous pouvez le télécharger de nouveau à tout moment depuis la page Publications."
                },
                "messages": {
                    "saved": "Publication enregistrée",
                    "enabled": "Publication activée",
                    "disabled": "Publication désactivée",
                    "download_failed": "Impossible de télécharger le paquet. Actualisez la page et réessayez."
                }
            },
            "journal": {
                "title": "Journal des lancements",
                "unknown_scenario": "Scénario indisponible",
                "back": "Vers les publications",
                "revoke": "Révoquer la tentative",
                "revoke_confirm": "Révoquer cette tentative ? L'apprenant perd l'accès à la conversation, et les envois qui n'ont pas encore abouti sont annulés.",
                "retry_delivery": "Réessayer",
                "empty_launches": "Aucun lancement pour le moment.",
                "empty_events": "Aucun événement pour le moment.",
                "no_deliveries": "Cette tentative n'a pas d'envoi.",
                "not_held_quota_charged": "N'a pas eu lieu, quota décompté",
                "relaunches": "retours : {value}",
                "last_launch": "dernier lancement : {value}",
                "result_deadline": "En attente de l'évaluation jusqu'au {value}",
                "learner_contacts": "Adresse envoyée par le système de formation : {email}. Lancé depuis : {ip}",
                "score_passed": "{value} — réussi",
                "score_failed": "{value} — échoué",
                "tabs": {
                    "launches": "Tentatives",
                    "events": "Événements"
                },
                "headers": {
                    "learner": "Apprenant",
                    "user": "Compte",
                    "attempt": "Tentative",
                    "status": "Statut",
                    "game": "Conversation",
                    "started_at": "Démarré",
                    "actions": " ",
                    "event_type": "Événement",
                    "refusal": "Motif",
                    "request_proof": "Preuve de la requête",
                    "ip": "Adresse",
                    "user_agent": "Client",
                    "happened_at": "Quand"
                },
                "launch_status": {
                    "created": "Lien émis",
                    "started": "En cours",
                    "not_held": "N'a pas eu lieu",
                    "awaiting_result": "En attente d'évaluation",
                    "result_ready": "Résultat transmis",
                    "evaluation_failed": "Pas d'évaluation",
                    "result_timed_out": "Délai d'attente dépassé",
                    "assignment_changed": "Attribution modifiée",
                    "revoked": "Révoquée"
                },
                "delivery": {
                    "version": "Version",
                    "status": "Statut",
                    "outcome": "Issue",
                    "result": "Résultat",
                    "score": "Score",
                    "attempts": "Essais",
                    "last_attempt": "Dernier essai",
                    "external_state": "État dans le système de formation"
                },
                "delivery_status": {
                    "pending": "En file d'attente",
                    "in_progress": "Envoi en cours",
                    "done": "Terminé",
                    "needs_attention": "Nécessite une action"
                },
                "delivery_outcome": {
                    "accepted": "Accepté",
                    "confirmed": "Confirmé",
                    "rejected_by_external": "Rejeté",
                    "retry": "Nouvel essai programmé",
                    "cancelled": "Annulé",
                    "assignment_changed": "Attribution modifiée"
                },
                "result": {
                    "passed": "Réussi",
                    "failed": "Échoué",
                    "not_held": "N'a pas eu lieu",
                    "no_result": "Aucun résultat"
                },
                "refusal": {
                    "publication_disabled": "Publication désactivée",
                    "publication_draft": "Publication à l'état de brouillon",
                    "publication_expired": "Publication expirée",
                    "feature_disabled": "Lancement externe désactivé",
                    "connection_disabled": "Connexion désactivée",
                    "launch_limit_reached": "Limite de lancements atteinte",
                    "daily_budget_exhausted": "Budget quotidien épuisé",
                    "attempts_exhausted": "Tentatives épuisées",
                    "quota_exhausted": "Quota de l'organisation épuisé",
                    "user_limit_reached": "Plus de place disponible",
                    "scenario_unavailable": "Scénario indisponible",
                    "assignment_check_unavailable": "Vérification de l'attribution indisponible",
                    "code_invalid": "Lien déjà utilisé ou expiré",
                    "channel_verification_failed": "Le système de formation n'a pas confirmé la requête",
                    "external_system_unavailable": "Le système de formation n'a pas répondu à la vérification de l'attribution",
                    "user_not_found": "Aucun compte pour cet apprenant",
                    "user_unavailable": "Compte de l'apprenant désactivé",
                    "user_deleted": "Compte de l'apprenant supprimé",
                    "email_taken_linking_disabled": "L'email appartient à un autre compte",
                    "service_role_not_allowed": "Un compte de service ne peut pas s'entraîner",
                    "unverified_request": "Requête non confirmée"
                },
                "event_type": {
                    "launch_refused": "Lancement refusé",
                    "exchange_refused": "Lien refusé",
                    "exchange_succeeded": "Lien utilisé"
                },
                "request_proof": {
                    "unverified": "Non confirmée",
                    "assignment_verified": "Attribution confirmée"
                },
                "messages": {
                    "retry_queued": "Nouvel essai mis en file d'attente",
                    "revoked": "Tentative révoquée"
                }
            }
        }
    },
    "voiceSession": {
        "mode": {
            "training": "Entraînement",
            "interview": "Entretien"
        },
        "load": {
            "loading": "Chargement de la session…",
            "failed": "Impossible de charger la session. Vérifiez votre connexion et réessayez.",
            "scenarioFailed": "Le scénario n'a pas pu être chargé",
            "scenarioRetry": "Réessayer"
        },
        "leave": {
            "confirm": "La conversation est en cours. Quitter la page ne l'arrêtera pas, et le temps continue de s'écouler. Quitter la page ?",
            "confirmEnd": "La conversation est en cours. Si vous quittez la page, elle se terminera et sera évaluée sur ce que vous aurez réussi à aborder. Quitter la page ?"
        },
        "elsewhere": {
            "interviewTitle": "L'entretien est ouvert dans un autre onglet",
            "interviewText": "L'entretien est en cours dans un autre onglet ou sur un autre appareil. Poursuivez-le là-bas — vous pouvez fermer cet onglet.",
            "conversationTitle": "La conversation est ouverte dans un autre onglet",
            "conversationText": "La conversation est en cours dans un autre onglet ou sur un autre appareil. Poursuivez-la là-bas — vous pouvez fermer cet onglet."
        },
        "prep": {
            "header": {
                "backToSessions": "Aux sessions",
                "themeToggleAriaLabel": "Changer de thème"
            },
            "scenario": {
                "sectionLabel": "Scénario",
                "competenceLabel": "Compétence évaluée",
                "gameNumber": "Session #{number}",
                "duration": "{minutes} min",
                "readFull": "Lire en entier",
                "generalLabel": "Informations générales",
                "playerLabel": "Informations pour vous"
            },
            "selfCamera": {
                "previewLabel": "Aperçu de votre caméra",
                "off": "La caméra est éteinte"
            },
            "notes": {
                "empty": "Vide"
            },
            "start": {
                "button": "Démarrer la session",
                "interviewButton": "Démarrer l'entretien",
                "resumeButton": "Retour à la conversation",
                "resumeHint": "La conversation est déjà en cours — le temps continue de s'écouler."
            }
        },
        "equipment": {
            "status": {
                "checking": "Vérification des appareils",
                "waiting": "En attente d'autorisation",
                "denied": "Accès refusé",
                "busy": "Appareil occupé",
                "noCamera": "Pas de caméra",
                "missing": "Pas de microphone",
                "dismissed": "Accès non accordé",
                "ready": "Appareils prêts"
            },
            "checking": {
                "title": "Vérification de votre microphone et de votre caméra…"
            },
            "waiting": {
                "title": "Autoriser l'accès au microphone",
                "cameraTitle": "Autoriser l'accès à la caméra",
                "description": "La demande d'autorisation du navigateur est déjà ouverte. Sans microphone, la conversation ne peut pas commencer."
            },
            "denied": {
                "title": "Le navigateur bloque le microphone",
                "cameraTitle": "Le navigateur bloque la caméra",
                "description": "Votre navigateur a mémorisé le blocage. Autorisez l'accès au microphone dans les paramètres du site et rechargez la page.",
                "cameraDescription": "Votre navigateur a mémorisé le blocage. Autorisez l'accès à la caméra dans les paramètres du site et rechargez la page.",
                "showInstructions": "Comment faire",
                "hideInstructions": "Masquer",
                "chromeEdge": {
                    "browser": "Chrome et Edge",
                    "text": "Cliquez sur l'icône de cadenas à gauche de la barre d'adresse, ouvrez « Paramètres du site », autorisez « Microphone » et rechargez la page."
                },
                "safari": {
                    "browser": "Safari",
                    "text": "Ouvrez le menu Safari → « Réglages pour ce site web », autorisez « Microphone » et rechargez la page."
                },
                "firefox": {
                    "browser": "Firefox",
                    "text": "Cliquez sur l'icône du microphone dans la barre d'adresse, supprimez le blocage pour ce site et rechargez la page."
                },
                "system": {
                    "title": "Votre système empêche le navigateur d'accéder au microphone",
                    "cameraTitle": "Votre système empêche le navigateur d'accéder à la caméra",
                    "macos": "macOS : Réglages système → Confidentialité et sécurité → Microphone (ou Caméra) → activez votre navigateur, puis redémarrez-le.",
                    "windows": "Windows : Paramètres → Confidentialité et sécurité → Microphone (ou Caméra) → autorisez l'accès pour les applications et votre navigateur, puis cliquez sur « Réessayer »."
                }
            },
            "busy": {
                "title": "Le microphone est utilisé par une autre application",
                "cameraTitle": "La caméra est utilisée par une autre application",
                "description": "C'est généralement un appel resté ouvert en arrière-plan. Fermez-le et cliquez sur « Réessayer ».",
                "retry": "Réessayer"
            },
            "noCamera": {
                "title": "Pas de caméra",
                "description": "On vous entendra, mais on ne vous verra pas.",
                "requiredByScenario": "Cette conversation nécessite une caméra. Connectez-en une pour continuer."
            },
            "missing": {
                "title": "Aucun microphone détecté",
                "description": "Connectez un microphone et cliquez sur « Réessayer ». La conversation ne peut pas commencer sans lui."
            },
            "dismissed": {
                "title": "L'accès au microphone n'a pas été accordé",
                "cameraTitle": "L'accès à la caméra n'a pas été accordé",
                "description": "La fenêtre du navigateur a été fermée sans réponse. Cliquez sur « Réessayer » et autorisez l'accès."
            },
            "ready": {
                "title": "Appareils prêts"
            },
            "micLabel": "Microphone",
            "cameraLabel": "Caméra",
            "chooseMic": "Choisir le microphone",
            "chooseCamera": "Choisir la caméra",
            "micLevelHint": "Dites quelque chose",
            "speakerValue": "Haut-parleur : {name}",
            "configure": "Configurer",
            "dialog": {
                "title": "Appareils",
                "lockedDuringConversation": "Les appareils ne peuvent pas être modifiés pendant la conversation.",
                "micSelectLabel": "Microphone",
                "cameraSelectLabel": "Caméra",
                "speakerSelectLabel": "Haut-parleur",
                "noCameraOption": "Pas de caméra",
                "record": "Enregistrer 3 secondes",
                "recording": "Enregistrement…",
                "recordFailed": "Impossible d'enregistrer. Réessayez.",
                "listen": "Écouter",
                "playing": "Lecture en cours…",
                "done": "Terminé",
                "closeAriaLabel": "Fermer la boîte de dialogue"
            },
            "unnamed": {
                "microphone": "Microphone {number}",
                "camera": "Caméra {number}",
                "speaker": "Haut-parleur {number}"
            },
            "cameraWarmup": {
                "preview": "La caméra s'allume",
                "title": "Microphone prêt",
                "description": "La caméra va suivre — en général en une ou deux secondes.",
                "slowHint": "La caméra ne s'allume pas ? Choisissez-en une autre via « Configurer »."
            }
        },
        "recording": {
            "videoAndAudio": "La conversation et la vidéo sont enregistrées.",
            "audioOnly": "La conversation est enregistrée.",
            "accessSelfAndEvaluators": "L'enregistrement est accessible à vous-même et à toute personne qui évalue votre travail.",
            "accessEvaluators": "L'enregistrement est accessible à toute personne qui évalue votre travail."
        },
        "scenario": {
            "video": "Vidéo de l'auteur du scénario"
        },
        "notes": {
            "title": "Notes de session",
            "placeholder": "Ce que vous souhaitez pratiquer, des formulations que vous avez préparées",
            "saving": "Enregistrement…",
            "saved": "Enregistré",
            "saveError": "Impossible d'enregistrer",
            "visibility": "Les notes sont visibles par vous et par toute personne qui évalue la session.",
            "unsupported": "Ces notes contiennent des éléments qui ne peuvent pas être modifiés ici. Elles restent inchangées."
        },
        "stage": {
            "agentState": {
                "speaking": "Parle",
                "listening": "Écoute",
                "thinking": "Réfléchit"
            },
            "micOffWarning": "Le microphone est coupé — votre interlocuteur ne peut pas vous entendre",
            "micOnAriaLabel": "Couper le microphone",
            "micOffAriaLabel": "Activer le microphone",
            "micOff": "Microphone coupé",
            "micOnAnnouncement": "Microphone activé",
            "captionsLabel": "Sous-titres",
            "captionsOnAriaLabel": "Masquer les sous-titres",
            "captionsOffAriaLabel": "Afficher les sous-titres",
            "talkBalance": {
                "title": "Équilibre de parole",
                "you": "Vous",
                "interlocutor": "Interlocuteur"
            },
            "connectionQuality": {
                "excellent": "Excellente connexion",
                "good": "Bonne connexion",
                "poor": "Connexion faible",
                "unknown": "Qualité de connexion inconnue"
            },
            "selfCameraLabel": "Vous",
            "timeWarning": {
                "lastMinute": "Une minute restante — il est temps de conclure",
                "finalSeconds": "15 secondes — terminez votre idée"
            },
            "timeUp": {
                "title": "Le temps est écoulé",
                "text": "La conversation se terminera d'elle-même ; elle ne peut pas être prolongée.",
                "closing": "Fermeture de la conversation…"
            },
            "voiceOnly": "Mode vocal — ce scénario n'a pas de vidéo",
            "interlocutorConnecting": {
                "title": "L'interlocuteur se connecte",
                "hint": "En général 2–4 secondes"
            },
            "layout": {
                "label": "Côte à côte",
                "sideTitle": "Placer côte à côte",
                "focusTitle": "Agrandir l'interlocuteur"
            }
        },
        "panels": {
            "scenario": "Scénario",
            "transcript": "Transcription",
            "transcriptEmpty": "Les réponses terminées apparaîtront ici.",
            "notes": "Notes",
            "characterMemoryTab": "Ce dont le personnage se souvient",
            "openAriaLabel": "Ouvrir le panneau « {panel} »",
            "closeAriaLabel": "Fermer le panneau « {panel} »"
        },
        "sound": {
            "label": "Son",
            "volumeLabel": "Volume",
            "speakerLabel": "Haut-parleur"
        },
        "end": {
            "button": "Terminer",
            "confirmTitle": "Terminer la conversation ?",
            "elapsed": "Temps écoulé : {elapsed} sur {total}.",
            "partialEvaluationNotice": "La conversation sera évaluée sur ce que vous aurez réussi à aborder.",
            "continue": "Continuer",
            "notSent": "La conversation se terminera à l'heure prévue : le serveur n'a pas répondu à la demande de fin."
        },
        "wait": {
            "title": "Préparation de la conversation",
            "hint": "Cela prend généralement 1–3 minutes. Ne fermez pas la page — nous démarrerons automatiquement.",
            "nextTry": "Prochaine tentative dans {time}",
            "trying": "Tentative de démarrage…",
            "retrying": "Pas encore. Nouvelle tentative dans {time}",
            "cancel": "Annuler",
            "failed": {
                "title": "Impossible de démarrer la conversation",
                "text": "Aucune place n'est disponible pour le moment. Les réglages du micro et de la caméra sont enregistrés — réessayez dans quelques minutes.",
                "retry": "Réessayer"
            }
        },
        "connection": {
            "reconnecting": "Connexion perdue, reconnexion en cours…",
            "restored": "Connexion rétablie",
            "failed": "Impossible de rétablir la connexion",
            "retry": "Réessayer"
        },
        "hotkeys": {
            "title": "Raccourcis clavier",
            "showHintAriaLabel": "Afficher les raccourcis clavier",
            "micToggle": "Activer/désactiver le microphone",
            "scenarioPanel": "Scénario : ouvrir et fermer le panneau",
            "transcriptPanel": "Transcription",
            "notesPanel": "Notes",
            "captionsToggle": "Activer/désactiver les sous-titres",
            "closeTopLayer": "Fermer le panneau, la popover ou le dialogue",
            "endConfirm": "Terminer — ouvre la confirmation",
            "showHint": "Afficher cette astuce"
        },
        "intro": {
            "candidate": {
                "greeting": "Bonjour, {name} !",
                "leadWithVacancy": "{organization} vous invite à un entretien avec un interlocuteur virtuel pour le poste « {vacancy} ».",
                "duration": "L'entretien dure environ {minutes} min.",
                "requirementsTitle": "Ce dont vous aurez besoin",
                "requirementMic": "Un microphone fonctionnel, idéalement un casque",
                "requirementCameraRequired": "Caméra activée : elle est obligatoire pour cet entretien",
                "requirementCameraOptional": "Une caméra n'est pas obligatoire, mais elle rend la conversation plus naturelle",
                "requirementBrowser": "Un ordinateur avec une version récente de Chrome, Edge ou Safari",
                "requirementNetwork": "Une connexion stable et un endroit calme où personne ne vous interrompra",
                "consentTextLabel": "Texte de consentement",
                "consentAccept": "J'ai pris connaissance du texte et je consens au traitement de mes données personnelles",
                "next": "Suivant"
            },
            "launch": {
                "title": "Conversation d'entraînement",
                "lead": "Vous allez vous entretenir avec un interlocuteur virtuel. La conversation est enregistrée et évaluée, et le résultat sera transmis à votre système de formation.",
                "requirementsTitle": "Ce dont vous aurez besoin",
                "requirementMic": "Un microphone fonctionnel, idéalement un casque",
                "requirementCamera": "Une caméra n'est pas obligatoire, mais elle rend la conversation plus vivante",
                "requirementBrowser": "Un ordinateur avec une version récente de Chrome, Edge ou Safari",
                "requirementNetwork": "Une connexion stable et un endroit calme où personne ne vous interrompra",
                "start": "Démarrer"
            }
        },
        "finished": {
            "candidate": {
                "title": "Merci !",
                "text": "L'entretien est terminé. Le résultat sera transmis au recruteur, qui vous contactera. Vous pouvez fermer cette page dès à présent."
            },
            "launch": {
                "title": "Merci !",
                "text": "La conversation est terminée. Le résultat apparaîtra dans votre système de formation une fois l'évaluation prête. Vous pouvez fermer cette page dès à présent."
            }
        },
        "closeDialogAriaLabel": "Fermer la boîte de dialogue"
    },
    "loopAvatars": {
        "title": "Avatars en boucle",
        "upload": "Téléverser un avatar",
        "newVersion": "Nouvelle version",
        "newVersionHint": "« {name} », version actuelle {version}. Le nouveau paquet remplace les vidéos dans tous les profils utilisant cet avatar.",
        "edit": "Modifier l'avatar",
        "delete": "Supprimer l'avatar",
        "empty": "Aucun avatar pour le moment",
        "headers": {
            "poster": "Affiche",
            "name": "Nom",
            "gender": "Genre",
            "emotion": "Émotion",
            "visibility": "Visibilité",
            "version": "Version",
            "profiles": "Profils"
        },
        "gender": {
            "male": "Masculin",
            "female": "Féminin"
        },
        "emotion": {
            "calm": "Calme",
            "friendly": "Amical",
            "strict": "Strict"
        },
        "visibility": {
            "all": "Toutes les entreprises"
        },
        "fields": {
            "package": "Paquet de l'avatar (.zip)"
        },
        "packageHint": "ZIP jusqu'à 100 Mo avec manifest.json, listen.mp4, talk.mp4, transitions.json et poster.jpg",
        "validation": {
            "packageTooLarge": "Le paquet ne doit pas dépasser 100 Mo"
        },
        "errors": {
            "requestFailed": "Échec de la requête. Veuillez réessayer."
        },
        "confirmDetach": "Profils à dissocier : {count}. Ils passeront à la photo. Enregistrer ?",
        "confirmDelete": "Supprimer l'avatar « {name} » ?",
        "confirmDeleteWithProfiles": "L'avatar « {name} » est utilisé dans des profils : {count}. Ils passeront à la photo. Supprimer ?"
    },
    "ttsVoices": {
        "title": "Voix TTS",
        "create": "Ajouter une voix",
        "edit": "Modifier la voix",
        "delete": "Supprimer la voix",
        "replaceSample": "Remplacer l'échantillon",
        "replaceSampleHint": "« {name} », version actuelle de l'échantillon {version}. Le nouvel échantillon sera utilisé dans tous les profils avec cette voix.",
        "empty": "Aucune voix pour le moment",
        "play": "Écouter l'échantillon",
        "stop": "Arrêter",
        "headers": {
            "name": "Nom",
            "provider": "Fournisseur",
            "externalId": "ID de la voix",
            "gender": "Genre",
            "languages": "Langues",
            "visibility": "Visibilité",
            "sample": "Échantillon",
            "profiles": "Profils"
        },
        "gender": {
            "male": "Masculin",
            "female": "Féminin"
        },
        "visibility": {
            "all": "Toutes les entreprises"
        },
        "fields": {
            "sample": "Échantillon de la voix",
            "speed": "Vitesse de parole"
        },
        "sampleHint": "MP3, MP4 ou M4A jusqu'à 5 Mo",
        "sampleOptionalHint": "Facultatif — l'échantillon sera généré avec la voix à partir de son ID. MP3, MP4 ou M4A jusqu'à 5 Mo",
        "synthesizeSample": "Générer à nouveau",
        "speedChangedHint": "Générez à nouveau l'échantillon de la voix pour entendre la nouvelle vitesse.",
        "speedSamplePromptTitle": "Vitesse modifiée",
        "speedSamplePrompt": "L'échantillon est toujours lu à la vitesse précédente. Le générer à nouveau ? L'échantillon actuel sera remplacé.",
        "saveAndSynthesize": "Enregistrer et générer",
        "saveOnly": "Enregistrer uniquement",
        "validation": {
            "sampleTooLarge": "L'échantillon ne doit pas dépasser 5 Mo"
        },
        "errors": {
            "requestFailed": "Échec de la requête. Veuillez réessayer.",
            "sampleUnavailable": "Impossible de lire l'échantillon"
        },
        "confirmDetach": "Profils à dissocier : {count}. Ils passeront à la voix du connecteur. Enregistrer ?",
        "confirmDelete": "Supprimer la voix « {name} » ?",
        "confirmDeleteWithProfiles": "La voix « {name} » est utilisée dans des profils : {count}. Ils passeront à la voix du connecteur. Supprimer ?",
        "picker": {
            "none": "Voix par défaut",
            "empty": "Aucune voix de ce genre dans le catalogue",
            "loadError": "Impossible de charger les voix",
            "playSample": "Écouter l'échantillon : {name}",
            "stopSample": "Arrêter l'échantillon : {name}",
            "sampleUnavailable": "Échantillon indisponible"
        }
    },
    "realtimeAvatars": {
        "title": "Avatars Live",
        "create": "Ajouter un avatar",
        "edit": "Modifier l'avatar",
        "delete": "Supprimer l'avatar",
        "preview": "Regarder l'aperçu",
        "empty": "Aucun avatar pour le moment",
        "headers": {
            "poster": "Vignette",
            "name": "Nom",
            "provider": "Fournisseur",
            "externalId": "ID de l'avatar",
            "gender": "Genre",
            "visibility": "Visibilité",
            "profiles": "Profils",
            "models": "Modèles Anam"
        },
        "gender": {
            "male": "Masculin",
            "female": "Féminin"
        },
        "visibility": {
            "all": "Toutes les entreprises"
        },
        "nameHint": "Facultatif — le nom d'Anam sera utilisé",
        "externalIdHint": "Si vous modifiez l'ID, la vignette et l'aperçu sont rechargés depuis Anam",
        "errors": {
            "requestFailed": "Échec de la requête. Veuillez réessayer.",
            "previewUnavailable": "Impossible de lire l'aperçu"
        },
        "confirmDetach": "Profils à dissocier : {count}. Ils passeront à la photo. Enregistrer ?",
        "confirmDelete": "Supprimer l'avatar « {name} » ?",
        "confirmDeleteWithProfiles": "L'avatar « {name} » est utilisé dans des profils : {count}. Ils passeront à la photo. Supprimer ?",
        "picker": {
            "label": "Avatars Live",
            "empty": "Aucun avatar Live disponible pour ce profil",
            "emptyFiltered": "Aucun avatar Live de ce genre",
            "loadError": "Impossible de charger les avatars Live"
        }
    },
    "aiProfileAppearance": {
        "label": "Apparence",
        "photo": "Votre photo",
        "avatar": "Studio",
        "live": "Live",
        "mascot": "Mascotte",
        "filterGender": "Genre",
        "filterEmotion": "Émotion",
        "avatarsLabel": "Avatars",
        "avatarRequired": "Choisissez un avatar",
        "liveRequired": "Choisissez un avatar Live",
        "livePlaceholder": "Votre avatar Live apparaîtra ici",
        "empty": "Aucun avatar disponible pour ce profil",
        "emptyFiltered": "Aucun avatar ne correspond aux filtres",
        "loadError": "Impossible de charger les avatars",
        "playPreview": "Lire l'aperçu : {name}",
        "pausePreview": "Mettre l'aperçu en pause : {name}"
    },
  "emailStopList": {
    "title": "Liste de blocage des emails",
    "description": "Les emails à destination de ces adresses et domaines ne sont pas envoyés. Une entrée de domaine couvre toutes les adresses de ce domaine, mais pas ses sous-domaines.",
    "searchPlaceholder": "Rechercher par adresse ou domaine",
    "allReasons": "Tous les motifs",
    "add": "Ajouter",
    "addTitle": "Bloquer une adresse ou un domaine",
    "empty": "La liste de blocage est vide",
    "editNote": "Modifier la note",
    "headers": {
      "type": "Type",
      "value": "Adresse ou domaine",
      "reason": "Motif",
      "providerReply": "Réponse du service de messagerie",
      "note": "Note",
      "author": "Ajouté par",
      "createdAt": "Date d'ajout",
      "blockedCount": "Emails bloqués",
      "lastBlockedAt": "Dernier blocage"
    },
    "type": {
      "address": "Adresse",
      "domain": "Domaine"
    },
    "reason": {
      "manual": "Manuellement",
      "providerRejected": "Refusé par le service de messagerie"
    },
    "author": {
      "system": "Système"
    },
    "fields": {
      "value": "Adresse ou domaine",
      "valueHint": "Indiquez une adresse complète ou seulement un domaine. Un domaine bloque toutes ses adresses, mais pas les sous-domaines.",
      "note": "Note"
    },
    "errors": {
      "requestFailed": "Une erreur s'est produite. Veuillez réessayer."
    },
    "unblock": {
      "action": "Débloquer",
      "confirm": "Débloquer {value} ?",
      "resultTitle": "Résultat du déblocage",
      "result": {
        "removedEverywhere": "Débloqué. Le service de messagerie n'a pas cette adresse dans sa liste de blocage : les emails seront de nouveau envoyés.",
        "removedLocally": "Domaine débloqué. Les adresses de ce domaine qui ont leur propre entrée restent bloquées.",
        "providerNotConfigured": "Seule l'entrée de la plateforme a été supprimée : la connexion au service de messagerie n'est pas configurée, sa liste de blocage n'a donc pas été vérifiée.",
        "providerUnavailable": "Le service de messagerie est indisponible, réessayez plus tard. L'adresse reste bloquée.",
        "stillListedAtProvider": "L'adresse figure dans la liste de blocage du service de messagerie. Retirez-la dans le panneau du service, puis cliquez sur « Débloquer à nouveau ». Si le panneau n'affiche pas l'adresse, elle figure dans la liste de blocage globale du service et ne peut pas en être retirée."
      },
      "openPanel": "Ouvrir le panneau du service de messagerie",
      "panelPath": "Où la retirer : panneau du service de messagerie → Products → Email Service → votre ressource → onglet Stop Lists.",
      "retry": "Débloquer à nouveau"
    },
    "suggestions": {
      "text": "Le domaine {domain} compte {count} adresses bloquées. Bloquer tout le domaine ?",
      "block": "Bloquer le domaine",
      "confirm": "Bloquer le domaine {domain} ? Les emails vers toutes ses adresses ne seront plus envoyés. Les sous-domaines ne sont pas concernés et les entrées des adresses individuelles restent."
    },
    "check": {
      "title": "Vérifier une adresse",
      "hint": "Indique si les emails vers cette adresse sont bloqués par la plateforme ou par le service de messagerie",
      "placeholder": "Adresse email",
      "submit": "Vérifier",
      "resultFor": "Résultat pour {email}",
      "platform": "Liste de blocage de la plateforme",
      "platformListed": "Oui — entrée « {value} »",
      "provider": "Liste de blocage du service de messagerie",
      "listed": "Oui",
      "notListed": "Non",
      "providerReasons": "Motifs indiqués par le service de messagerie :",
      "providerNotConfigured": "La connexion au service de messagerie n'est pas configurée",
      "providerUnavailable": "Le service de messagerie est indisponible, réessayez plus tard"
    }
  }
}
